'use client';
import { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import React from 'react';
import {
   Box,
   Flex,
   Table,
   Tbody,
   Td,
   Text,
   Tr,
   useColorModeValue,
   useDisclosure,
   Drawer,
   DrawerOverlay,
   DrawerContent,
   DrawerCloseButton,
   DrawerHeader,
   DrawerBody,
   useOutsideClick,
   VStack,
   Spinner,
   useColorMode,
} from '@chakra-ui/react';
import Select from 'react-select';
import 'jspdf-autotable';
import Card from 'components/card/Card';
import { GridItem, Input } from '@chakra-ui/react';
import nodata from 'assets/img/nfts/no data.svg';
import { Button, Image, Thead, Th, Grid, IconButton } from '@chakra-ui/react';
import Download from '../../../../assets/img/nfts/download.svg';
import xls from '../../../../../src/assets/img/nfts/xls.svg';
import back from '../../../../../src/assets/img/nfts/back.svg';
import { Popover, PopoverTrigger, PopoverContent, PopoverBody } from '@chakra-ui/react';
import SalesDetails from 'components/salesDetails/SalesDetails';
import { deletePurchaseInvoice, getPurchaseInvoice } from '../../../../redux/actions/purchaseInvoice';
import { deleteRecord } from 'utils/util';
import SalesPurchaseFilter from '../components/SalesPurchaseFilter';
import { useDispatch, useSelector } from 'react-redux';
import cancel from '../../../../assets/img/nfts/cancel.svg';
import { deleteReportFormat, getReportFormat, getReportPurchaseDetail } from '../../../../redux/actions/reports';
import {
   createColumnHelper,
   flexRender,
   getCoreRowModel,
   getSortedRowModel,
   useReactTable,
} from '@tanstack/react-table';
import { ChevronDownIcon, ChevronUpIcon, SearchIcon } from '@chakra-ui/icons';
import { getShareCompanyOptions } from 'utils/util';
import DotIcon from '../../../../assets/img/nfts/dot.svg';
import { REPORT_TYPE } from 'constants';
import { renderDynamicDropdown } from '../../../../components/ui/DynamicDropdown';
import { jsPDF } from 'jspdf';
import * as XLSX from 'xlsx-js-style';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import PeriodDatePicker from 'components/RangePicker/PeriodDatePicker';
import { useGlobal, useUser, useBusinessType } from '../../../../contexts';
import { IoFilterOutline } from 'react-icons/io5';
import ColumnShowHide from '../components/Columnshowhide';
import { MdCompress, MdDelete, MdExpand, MdOutlineRefresh } from 'react-icons/md';
import { LucideEdit } from 'lucide-react';
import { FiPlusCircle } from 'react-icons/fi';
import { deleteRecordForSales } from 'utils/util';
import Loader from 'views/admin/default/Loader';
import DeletePasswordModal from 'views/admin/sales/Pages/SalesInvoiceMaster/DeletePasswordModal';
import { VariableSizeList } from 'react-window';
const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);

const PurchaseDetail = () => {
   const dispatch = useDispatch();
   const fromDateInputRef = useRef(null);
   const abortControllerRef = useRef(null);
   const dataCacheRef = useRef({});
   const columnHelper = createColumnHelper();
   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const backgroundColor = useColorModeValue('white', '#101F4A');
   const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
   const controlBg = useColorModeValue('#FFFFFF', '#2D3748');
   const controlBorder = useColorModeValue('#E2E8F0', '#4A5568');
   const controlBorderHover = useColorModeValue('#CBD5E0', '#718096');
   const focusBoxShadow = useColorModeValue('0 0 0 1px #3182CE', '0 0 0 1px #63B3ED');
   const placeholderColor = useColorModeValue('#A0AEC0', '#718096');
   const optionBg = useColorModeValue('#FFFFFF', '#2D3748');
   const optionHoverBg = useColorModeValue('#EDF2F7', '#4A5568');
   const menuBg = useColorModeValue('#FFFFFF', '#2D3748');
   const menuBorder = useColorModeValue('#E2E8F0', '#4A5568');
   const indicatorColor = useColorModeValue('#718096', '#A0AEC0');
   const indicatorHoverColor = useColorModeValue('#4A5568', '#CBD5E0');
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const [filteredResults, setFilteredResults] = useState(null);
   const { companyList, company } = useGlobal();
   const { userGlobalSettingsData } = useGlobal();
   const [fromDate, setFromDate] = useState(null);
   const [isFilterLoading, setIsFilterLoading] = useState(false);
   const isFirstRenderFilter = useRef(true);
   const [companyFilter, setCompanyFilter] = useState([]);
   const [allExpanded, setAllExpanded] = useState(false);
   const [reportType, setReportType] = useState('date');
   const [formatType, setFormatType] = useState('with_item_detail');
   const [expandedItems, setExpandedItems] = useState({});
   const [sorting, setSorting] = useState([]);
   const [columnVisibility, setColumnVisibility] = useState({ brokername: false });
   const dbName = company?.dbName;
   const [searchQuery, setSearchQuery] = useState('');
   const [flattenedData, setFlattenedData] = useState([]);
   const [containerHeight, setContainerHeight] = useState(700);
   const listRef = useRef(null);
   const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('');
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const icon = useColorModeValue('#000000', '#ffffff');
   const [dateRange, setDateRange] = useState(() => {
      const today = new Date();
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(today.getDate() - 6);

      return {
         fromDate: sevenDaysAgo.toISOString().split('T')[0], // last 7th day
         toDate: today.toISOString().split('T')[0], // today
      };
   });
   const { isOpen: isFilterOpen, onOpen: onFilterOpen, onClose: onFilterClose } = useDisclosure();
   const reportformat = useSelector((state) => state.reports?.reportFormat || []);
   const [showHideData, setShowHideData] = useState({});
   const [isFetching, setIsFetching] = useState(false);
   const [isModalOpen, setIsModalOpen] = useState(false);
   const [dataId, setDataId] = useState(null);
   const [isShowHideColumn, setIsShowHideColumn] = useState(false);
   const allowedDefNames = ['PurchaseDetailDate', 'PurchaseDetailParty', 'PurchaseDetailBroker'];
   const dynamicOptions = reportformat
      .filter((item) => item.defName && allowedDefNames.includes(item.defName))
      .map((item) => ({
         id: item.id,
         value: item.defName && item.title,
         label: item.title,
         isDynamic: true,
         formatData: item,
      }));
   const dynamicValues = dynamicOptions.map((option) => option.value);
   const dynamicOptionValues = dynamicOptions.find((option) => option.value === reportType);
   const dynamicEditOption = dynamicOptionValues?.formatData.defName;
   const handleReportTypeChange = (selectedOption) => {
      setReportType(selectedOption.value);
      setExpandedItems({});
      dispatch(getReportFormat());
   };
   const { user } = useUser();
   const admin = user?.isAdmin;
   const rights = user?.userRights?.find((ur) => ur?.companyId === user?.loginhistory?.companyId);
   const { businessTypes } = useBusinessType();
   const isTextile = businessTypes?.businessType === 'TEXTILE';
   const companyId = Number(localStorage.getItem('companyId'));
   const userRights = user?.user?.userRights || user?.userRights;
   const purchaseInvoiceRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.purchaseinvoice
      : null;
   const purchaseReturnRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.purchasereturn
      : null;
   const isStaticReportType = ['date', 'party', 'broker'].includes(reportType);
   const getColumnsReportsSalesDetail = useCallback((formatType, reportType) => {
      const isPartyReport = reportType === 'party' || dynamicEditOption === 'PurchaseDetailParty';
      const isDateReport = dynamicEditOption === 'PurchaseDetailDate';

      const viewJson = dynamicOptionValues?.formatData?.viewJson || [];

      const convertBackendColor = (backendColor) => {
         if (!backendColor) return null;
         if (backendColor.startsWith('#')) return backendColor;
         if (backendColor.startsWith('0xff')) return '#' + backendColor.substring(4);
         if (/^[0-9A-Fa-f]{6}$/.test(backendColor)) return '#' + backendColor;
         return backendColor;
      };

      const getColumnInfo = (defName) => {
         // First try to find by defName, then by title
         const viewItem = viewJson.find(
            (item) =>
               item?.defName?.toLowerCase() === defName.toLowerCase() ||
               item?.title?.toLowerCase() === defName.toLowerCase(),
         );

         if (!viewItem || isStaticReportType) {
            // Return default values if no customization found or for static report types
            return {
               title: defName,
               isShow: true,
               color: textColor,
               isBold: false,
               isItalic: false,
               orderNo: 0,
               flex: 1,
            };
         }

         return {
            title: viewItem.title || defName,
            isShow: viewItem.isShow === 'true' || viewItem.isShow === true,
            color: viewItem.color ? convertBackendColor(viewItem.color) : textColor,
            isBold: viewItem.isBold === 'true' || viewItem.isBold === true,
            isItalic: viewItem.isItalic === 'true' || viewItem.isItalic === true,
            orderNo: viewItem.orderNo ? parseInt(viewItem.orderNo) : 0,
            flex: viewItem.flex ? parseInt(viewItem.flex) : 1,
         };
      };

      const baseColumns = [
         {
            id: 'transactionAt',
            header: getColumnInfo('date').title,
            accessor: 'transactionAt',
            isShow: getColumnInfo('date').isShow,
            color: getColumnInfo('date').color,
            isBold: getColumnInfo('date').isBold,
            isItalic: getColumnInfo('date').isItalic,
            orderNo: getColumnInfo('date').orderNo,
            flex: getColumnInfo('date').flex,
            cell: (info) => {
               const value = info.getValue();
               return value ? moment(value).format('DD-MM-YYYY') : value;
            },
         },
         {
            id: 'docno',
            header: getColumnInfo('doc').title,
            accessor: 'docno',
            isShow: getColumnInfo('doc').isShow,
            color: getColumnInfo('doc').color,
            isBold: getColumnInfo('doc').isBold,
            isItalic: getColumnInfo('doc').isItalic,
            orderNo: getColumnInfo('doc').orderNo,
            flex: getColumnInfo('doc').flex,
         },
         ...(!isPartyReport
            ? [
               {
                  id: 'accountname',
                  header: getColumnInfo('party').title,
                  accessor: 'accountname',
                  isShow: getColumnInfo('party').isShow,
                  color: getColumnInfo('party').color,
                  isBold: getColumnInfo('party').isBold,
                  isItalic: getColumnInfo('party').isItalic,
                  orderNo: getColumnInfo('party').orderNo,
                  flex: getColumnInfo('party').flex,
               },
            ]
            : []),
         ...(reportType === 'date'
            ? [
               {
                  id: 'mobile',
                  header: getColumnInfo('mobile').title,
                  accessor: 'mobile',
                  isShow: getColumnInfo('mobile').isShow,
                  color: getColumnInfo('mobile').color,
                  isBold: getColumnInfo('mobile').isBold,
                  isItalic: getColumnInfo('mobile').isItalic,
                  orderNo: getColumnInfo('mobile').orderNo,
                  flex: getColumnInfo('mobile').flex,
               },
            ]
            : []),
         {
            id: 'daybookname',
            header: getColumnInfo('daybook').title,
            accessor: 'daybookname',
            isShow: getColumnInfo('daybook').isShow,
            color: getColumnInfo('daybook').color,
            isBold: getColumnInfo('daybook').isBold,
            isItalic: getColumnInfo('daybook').isItalic,
            orderNo: getColumnInfo('daybook').orderNo,
            flex: getColumnInfo('daybook').flex,
         },
         {
            id: 'salesmanname',
            header: getColumnInfo('salesman').title,
            accessor: 'salesmanname',
            isShow: getColumnInfo('salesman').isShow,
            color: getColumnInfo('salesman').color,
            isBold: getColumnInfo('salesman').isBold,
            isItalic: getColumnInfo('salesman').isItalic,
            orderNo: getColumnInfo('salesman').orderNo,
            flex: getColumnInfo('salesman').flex,
         },
         {
            id: 'notes',
            header: getColumnInfo('notes').title,
            accessor: 'notes',
            isShow: getColumnInfo('notes').isShow,
            color: getColumnInfo('notes').color,
            isBold: getColumnInfo('notes').isBold,
            isItalic: getColumnInfo('notes').isItalic,
            orderNo: getColumnInfo('notes').orderNo,
            flex: getColumnInfo('notes').flex,
         },
         {
            id: 'totalQty1',
            header: getColumnInfo('qty').title,
            accessor: 'totalQty1',
            isNumeric: true,
            isShow: getColumnInfo('qty').isShow,
            color: getColumnInfo('qty').color,
            isBold: getColumnInfo('qty').isBold,
            isItalic: getColumnInfo('qty').isItalic,
            orderNo: getColumnInfo('qty').orderNo,
            flex: getColumnInfo('qty').flex,
         },
         {
            id: 'netAmount',
            header: getColumnInfo('netAmt').title,
            accessor: 'netAmount',
            isNumeric: true,
            isShow: getColumnInfo('netAmt').isShow,
            color: getColumnInfo('netAmt').color,
            isBold: getColumnInfo('netAmt').isBold,
            isItalic: getColumnInfo('netAmt').isItalic,
            orderNo: getColumnInfo('netAmt').orderNo,
            flex: getColumnInfo('netAmt').flex,
            cell: (info) => {
               const value = info.getValue();
               return `₹${Number(value || 0).toLocaleString()}`;
            },
         },
         {
            id: 'basicAmount',
            header: getColumnInfo('billAmt').title,
            accessor: 'basicAmount',
            isNumeric: true,
            isShow: getColumnInfo('billAmt').isShow,
            color: getColumnInfo('billAmt').color,
            isBold: getColumnInfo('billAmt').isBold,
            isItalic: getColumnInfo('billAmt').isItalic,
            orderNo: getColumnInfo('billAmt').orderNo,
            flex: getColumnInfo('billAmt').flex,
            cell: (info) => {
               const value = info.getValue();
               return `₹${Number(value || 0).toLocaleString()}`;
            },
         },
      ];

      if (formatType === 'with_item_detail') {
         let itemDetailColumns = [];

         if (reportType === 'date') {
            itemDetailColumns = [
               {
                  id: 'itemName',
                  header: getColumnInfo('itemName').title,
                  accessor: 'itemName',
                  isShow: getColumnInfo('itemName').isShow,
                  color: getColumnInfo('itemName').color,
                  isBold: getColumnInfo('itemName').isBold,
                  isItalic: getColumnInfo('itemName').isItalic,
                  orderNo: getColumnInfo('itemName').orderNo,
                  flex: getColumnInfo('itemName').flex,
                  cell: (info) => {
                     const value = info.getValue();
                     return (
                        <div
                           className="text-center px-2 py-1"
                           style={{
                              textAlign: 'center',
                              wordWrap: 'break-word',
                              whiteSpace: 'normal',
                              maxWidth: '200px',
                              minWidth: '150px',
                           }}
                           title={value}>
                           {value}
                        </div>
                     );
                  },
               },
               ...(isTextile ? [] : [{
                  id: 'serialNo',
                  header: getColumnInfo('serialNo').title,
                  accessorKey: 'serialNo',
                  isShow: getColumnInfo('serialNo').isShow,
                  color: getColumnInfo('serialNo').color,
                  isBold: getColumnInfo('serialNo').isBold,
                  isItalic: getColumnInfo('serialNo').isItalic,
                  orderNo: getColumnInfo('serialNo').orderNo,
                  flex: getColumnInfo('serialNo').flex,
               }]),
               {
                  id: 'itemRate',
                  header: getColumnInfo('rate').title,
                  accessor: 'itemRate',
                  isNumeric: true,
                  isShow: getColumnInfo('rate').isShow,
                  color: getColumnInfo('rate').color,
                  isBold: getColumnInfo('rate').isBold,
                  isItalic: getColumnInfo('rate').isItalic,
                  orderNo: getColumnInfo('rate').orderNo,
                  flex: getColumnInfo('rate').flex,
               },
            ];
         } else {
            itemDetailColumns = [
               {
                  id: 'itemName',
                  header: getColumnInfo('itemName').title,
                  accessor: 'itemName',
                  isShow: getColumnInfo('itemName').isShow,
                  color: getColumnInfo('itemName').color,
                  isBold: getColumnInfo('itemName').isBold,
                  isItalic: getColumnInfo('itemName').isItalic,
                  orderNo: getColumnInfo('itemName').orderNo,
                  flex: getColumnInfo('itemName').flex,
                  cell: (info) => {
                     const value = info.getValue();
                     return (
                        <div
                           className="text-center px-2 py-1"
                           style={{
                              textAlign: 'center',
                              wordWrap: 'break-word',
                              whiteSpace: 'normal',
                              maxWidth: '200px',
                              minWidth: '150px',
                           }}
                           title={value}>
                           {value}
                        </div>
                     );
                  },
               },
               ...(isTextile ? [] : [{
                  id: 'serialNo',
                  header: getColumnInfo('serialNo').title,
                  accessorKey: 'serialNo',
                  isShow: getColumnInfo('serialNo').isShow,
                  color: getColumnInfo('serialNo').color,
                  isBold: getColumnInfo('serialNo').isBold,
                  isItalic: getColumnInfo('serialNo').isItalic,
                  orderNo: getColumnInfo('serialNo').orderNo,
                  flex: getColumnInfo('serialNo').flex,
               }]),
               {
                  id: 'itemRate',
                  header: getColumnInfo('rate').title,
                  accessor: 'itemRate',
                  isNumeric: true,
                  isShow: getColumnInfo('rate').isShow,
                  color: getColumnInfo('rate').color,
                  isBold: getColumnInfo('rate').isBold,
                  isItalic: getColumnInfo('rate').isItalic,
                  orderNo: getColumnInfo('rate').orderNo,
                  flex: getColumnInfo('rate').flex,
               },
               ...(!isDateReport
                  ? [
                     {
                        id: 'hsnSac',
                        header: getColumnInfo('HSN/SAC').title || 'HSN/SAC',
                        accessor: 'hsnSac',
                        isShow: getColumnInfo('HSN/SAC').isShow,
                        color: getColumnInfo('HSN/SAC').color,
                        isBold: getColumnInfo('HSN/SAC').isBold,
                        isItalic: getColumnInfo('HSN/SAC').isItalic,
                        orderNo: getColumnInfo('HSN/SAC').orderNo,
                        flex: getColumnInfo('HSN/SAC').flex,
                     },
                     {
                        id: 'dueDays',
                        header: getColumnInfo('Due Days').title || 'Due Days',
                        accessor: 'dueDays',
                        isShow: getColumnInfo('Due Days').isShow,
                        color: getColumnInfo('Due Days').color,
                        isBold: getColumnInfo('Due Days').isBold,
                        isItalic: getColumnInfo('Due Days').isItalic,
                        orderNo: getColumnInfo('Due Days').orderNo,
                        flex: getColumnInfo('Due Days').flex,
                     },
                  ]
                  : []),
            ];
         }

         // Insert item details after account/mobile columns
         const insertIndex =
            reportType === 'date'
               ? baseColumns.findIndex((col) => col.id === 'mobile') + 1
               : baseColumns.findIndex((col) => col.id === 'docno') + 1;

         baseColumns.splice(insertIndex, 0, ...itemDetailColumns);
      }

      // Filter out columns where isShow is false
      return baseColumns
         .filter((col) => col.isShow !== false)
         .sort((a, b) => {
            const orderA = a.orderNo || 0;
            const orderB = b.orderNo || 0;
            return orderA - orderB;
         });
   });
   const companyIds = useMemo(
      () =>
         companyFilter.length > 0
            ? companyFilter
            : localStorage.getItem('companyId')
               ? [parseInt(localStorage.getItem('companyId'))]
               : [],
      [companyFilter],
   );
   const staticReportTypeOptions = [
      { value: 'date', label: 'Date' },
      { value: 'party', label: 'Party' },
      { value: 'broker', label: 'Broker' },
   ];

   const reportTypeOptions = [
      ...staticReportTypeOptions,
      ...(dynamicOptions.length > 0
         ? [
            {
               label: 'Custom Formats',
               options: dynamicOptions,
            },
         ]
         : []),
   ];
   const staticOption = staticReportTypeOptions.find((option) => option.value === reportType);

   const formatTypeOptions = [
      { value: 'with_item_detail', label: 'With Item Detail' },
      { value: 'without_item_detail', label: 'Without Item Detail' },
   ];

   useEffect(() => {
      dispatch(getReportFormat());
   }, [dispatch]);

   const formatOptionLabel = ({ label, isDynamic, id }, { context }) => (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
         <span>{label}</span>
         {isDynamic && context === 'menu' && (
            <button
               onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteFormat(id);
               }}
               style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  color: '#ff4d4f',
                  padding: '0 5px',
               }}
               title="Delete this format">
               <MdDelete />
            </button>
         )}
      </div>
   );

   const handleDeleteFormat = async (id) => {
      try {
         // Call the action creator
         await dispatch(deleteReportFormat(id));

         // Reset edit state if this was the currently edited format
         if (editData?.id === id) {
            setIsEditShowHide(false);
            setEditData({});
         }
         dispatch(getReportFormat());
      } catch (error) {
         // Errors are already handled in the action creator
         console.error('Delete error:', error);
      }
   };

   const handleCompanyChange = (selectedOptions) => {
      setCompanyFilter(selectedOptions ? selectedOptions : []);
   };

   const dynamicColumns = useMemo(() => {
      // Assuming reportformat[0] contains your format data
      const format = reportformat.find((f) => f.id === reportType) || reportformat[0];
      return getColumnsReportsSalesDetail(formatType, reportType, format);
   }, [formatType, reportType, reportformat]);

   const handleNextPage = () => {
      console.log('Next');
   };
   const handlePrevPage = () => {
      console.log('Prev');
   };

   useEffect(() => {
      const initialColumnVisibility = {};
      dynamicColumns.forEach((column) => {
         initialColumnVisibility[column.id] = column.id === 'brokername' ? false : true;
      });
      setColumnVisibility(initialColumnVisibility);
   }, [dynamicColumns]);

   const columnsData = useMemo(() => {
      return dynamicColumns.map((col, index) => ({
         key: col?.id,
         label: col?.header,
         title: col?.header,
         width: col?.width,
         index: index + 1,
         status: true,
      }));
   }, [dynamicColumns]);

   useEffect(() => {
      if (Object.keys(showHideData).length === 0) {
         setShowHideData(columnsData);
      }
   }, [showHideData, columnsData]);

   const columns = useMemo(() => {
      return dynamicColumns.map((column) =>
         columnHelper.accessor(column.id, {
            id: column.id,
            header: () => (
               <Text
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color={`${isDark ? '#fff' : '#000'}`}>
                  {column.header}
               </Text>
            ),
            cell: (info) => <Flex align="center">{info.getValue()}</Flex>,
         }),
      );
   }, [columnHelper, dynamicColumns, isDark]);
   const getVisibleColumnsCount = () => {
      return table.getAllColumns().filter((column) => column.getIsVisible()).length;
   };
   const [isEditShowHide, setIsEditShowHide] = useState(false); // State to store selected value
   const [editData, setEditData] = useState({}); // State to store selected value
   const salesReport = useSelector((state) => state.reports?.purchaseDetail || []);
   const daybookData = useSelector((state) => state.daybook?.list || []);
   const viewData = useSelector((state) => state?.purchaseInvoice?.single);
   const { viewDetail, paginate } = useMemo(() => {
      const data = viewData;
      const pagination = viewData?.pagination;
      return { viewDetail: data, paginate: pagination };
   }, [viewData, viewData?.pagination]);
   const [isEditFormOpen, setIsEditFormOpen] = React.useState(false);
   const [isOpenPurchaseReturnSingleView, setIsOpenPurchaseReturnSingleView] = React.useState(null);

   const { isOpen, onOpen, onClose } = useDisclosure();
   const searchTimeoutRef = useRef(null);
   const [isLoading, setIsLoading] = useState(false);

   const table = useReactTable({
      data: salesReport,
      columns,
      state: {
         sorting,
         columnVisibility,
      },
      onSortingChange: setSorting,
      onColumnVisibilityChange: setColumnVisibility,
      getCoreRowModel: getCoreRowModel(),
      getSortedRowModel: getSortedRowModel(),
      initialState: {
         columnVisibility: {
            brokername: false,
         },
      },
   });

   const calculateColumnWidths = () => {
      const visibleColumns = dynamicColumns.filter((col) => columnVisibility[col.id]);
      const totalFlex = visibleColumns.reduce((sum, col) => sum + (col.flex || 1), 0);
      const availableWidth = 100; // This represents 100% of the table width

      return visibleColumns.map((col) => {
         const flexValue = col.flex || 1;
         return `${(flexValue / totalFlex) * availableWidth}%`;
      });
   };

   const columnWidths = calculateColumnWidths();

   const toggleExpand = (id) => {
      setExpandedItems((prev) => ({
         ...prev,
         [id]: !prev[id],
      }));
   };

   useEffect(() => {
      if (!dateRange.fromDate) {
         const today = new Date();
         today.setFullYear(today.getFullYear() - 1);
         const formattedDate = today.toISOString().split('T')[0];
         setFromDate(formattedDate);
      }
   }, [dateRange.fromDate]);

   const companyOptions = useMemo(() => {
      return getShareCompanyOptions({ dbName, company: companyList });
   }, [companyList, dbName]);

   const storedCompanyId = localStorage.getItem('companyId');
   useEffect(() => {
      if (storedCompanyId && companyList.length > 0) {
         const companyId = parseInt(storedCompanyId);
         const matchingCompany = companyList.find((comp) => comp.id === companyId);
         if (matchingCompany) {
            setCompanyFilter([matchingCompany.id]);
         }
      }
   }, [companyList, storedCompanyId]);

   const handleDateRangeChange = (dates) => {
      if (!dates || dates.length !== 2) return;

      const [from, to] = dates.map((date) =>
         moment.isMoment(date)
            ? date.format('YYYY-MM-DD') // keep it local
            : moment(date).format('YYYY-MM-DD'),
      );

      setDateRange({ fromDate: from, toDate: to });
   };

   const fetchData = useCallback(
      async (searchQuery = '') => {
         if (isFetching) return;
         if (abortControllerRef.current) {
            abortControllerRef.current.abort();
         }

         abortControllerRef.current = new AbortController();
         setIsLoading(true);

         try {
            const companyIds =
               companyFilter.length > 0
                  ? companyFilter
                  : localStorage.getItem('companyId')
                     ? [parseInt(localStorage.getItem('companyId'))]
                     : [];

            if (dateRange.fromDate && dateRange.toDate && companyIds.length > 0) {
               const cacheKey = `${companyIds.toString()}-${reportType}-${dateRange.fromDate}-${dateRange.toDate
                  }-${searchQuery}`;

               // Return cached data if available
               if (dataCacheRef.current[cacheKey]) {
                  setFilteredResults(dataCacheRef.current[cacheKey]);
                  return;
               }

               const result = await dispatch(
                  getReportPurchaseDetail({
                     companyIds: companyIds.join(','),
                     type: reportType,
                     fromDate: dateRange.fromDate,
                     toDate: dateRange.toDate,
                     search: searchQuery,
                  }),
                  { signal: abortControllerRef.current.signal },
               );

               dataCacheRef.current[cacheKey] = result;
            }
         } catch (error) {
            if (error.name !== 'AbortError') {
               console.error('Error fetching purchase details:', error);
            }
         } finally {
            setIsLoading(false);
            setIsFetching(false);
            abortControllerRef.current = null;
         }
      },
      [companyFilter, dateRange.fromDate, dateRange.toDate, dispatch, isFetching, reportType], // Only keep dispatch as dependency
   );

   useEffect(() => {
      const timer = setTimeout(() => {
         fetchData(debouncedSearchQuery);
      }, 300); // Add debounce

      return () => clearTimeout(timer);
   }, [debouncedSearchQuery, dateRange.fromDate, dateRange.toDate, companyFilter, reportType, fetchData]);

   const handleSearchChange = (e) => {
      const value = e.target.value;
      setSearchQuery(value); // Update UI immediately

      // Clear any existing timeout
      if (searchTimeoutRef.current) {
         clearTimeout(searchTimeoutRef.current);
      }

      // Set a new timeout to update debounced value after typing stops
      searchTimeoutRef.current = setTimeout(() => {
         setDebouncedSearchQuery(value);
      }, 800); // 800ms delay - adjust as needed
   };

   // In useEffect cleanup
   useEffect(() => {
      return () => {
         if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
         }
      };
   }, []);

   useEffect(() => {
      const handler = setTimeout(() => {
         setDebouncedSearchQuery(searchQuery);
      }, 500);

      return () => {
         clearTimeout(handler);
      };
   }, [searchQuery]);

   const [expanded, setExpanded] = useState(false);
   const wrapperRef = useRef();
   useOutsideClick({
      ref: wrapperRef,
      handler: () => {
         if (searchQuery === '') setExpanded(false);
      },
   });

   useEffect(() => {
      return () => {
         if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
         }
      };
   }, []);

   // Add this useEffect to set initial expanded state when salesReport changes
   useEffect(() => {
      if (salesReport && salesReport.length > 0) {
         const initialExpandedState = {};

         if (reportType === REPORT_TYPE.party) {
            // Set company and account level expansions
            salesReport.forEach((companyData) => {
               initialExpandedState[`company-${companyData.companyId}`] = true;

               if (companyData.data && Array.isArray(companyData.data)) {
                  companyData.data.forEach((accountData) => {
                     initialExpandedState[`account-${accountData.accountId}`] = true;

                     // AUTO-EXPAND ITEMS: Add this section
                     if (accountData.data && Array.isArray(accountData.data)) {
                        accountData.data.forEach((transaction) => {
                           const hasMultipleItems =
                              transaction.purchaseLineItems &&
                              Array.isArray(transaction.purchaseLineItems) &&
                              transaction.purchaseLineItems.length > 1;

                           if (hasMultipleItems) {
                              initialExpandedState[`items-${transaction.id}`] = true;
                           }
                        });
                     }
                  });
               }
            });
         } else {
            // For date report type, auto-expand items too
            salesReport.forEach((dateItem) => {
               dateItem.data?.forEach((item) => {
                  if (item.data && Array.isArray(item.data)) {
                     item.data.forEach((transaction) => {
                        const hasMultipleItems =
                           transaction.purchaseLineItems &&
                           Array.isArray(transaction.purchaseLineItems) &&
                           transaction.purchaseLineItems.length > 1;

                        if (hasMultipleItems) {
                           initialExpandedState[`items-${transaction.id}`] = true;
                        }
                     });
                  }
               });
            });
         }

         setExpandedItems(initialExpandedState);
      }
   }, [salesReport, reportType]);

   const lastcompanyOptions = useMemo(() => {
      const currentUserCode = user?.loginhistory?.code;
      const currentCompanyId = user?.loginhistory?.companyId;

      // SHARED COMPANY MODE: When code is present
      if (currentUserCode) {
         // Find the company with matching ID AND matching dbName
         const sharedCompany = companyList.find(
            company => company.id === currentCompanyId && company.dbName === currentUserCode
         );

         if (sharedCompany) {
            return [{
               value: sharedCompany.id,
               label: sharedCompany.name,
               id: sharedCompany.id,
               name: sharedCompany.name,
            }];
         }

         // Fallback: try to find by dbName only
         const companiesWithDbName = companyList.filter(company => company.dbName === currentUserCode);
         if (companiesWithDbName.length > 0) {
            return companiesWithDbName.map(company => ({
               value: company.id,
               label: company.name,
               id: company.id,
               name: company.name,
            }));
         }

         return [];
      }

      // NORMAL MODE: When no code, show companies without dbName
      return companyList
         .filter(company => !company.dbName)
         .map(company => ({
            value: company.id,
            label: company.name,
            id: company.id,
            name: company.name,
         }));
   }, [companyList, user?.loginhistory?.code, user?.loginhistory?.companyId]);

   useEffect(() => {
      const handleKeyDown = (e) => {
         const isTargetInput =
            e.target.tagName === 'INPUT' ||
            e.target.tagName === 'TEXTAREA' ||
            e.target.tagName === 'SELECT' ||
            e.target.isContentEditable;

         if (e.key.toLowerCase() === 't' && !isTargetInput) {
            if (fromDateInputRef.current) {
               fromDateInputRef.current.focus();
            }
         }
      };

      document.addEventListener('keydown', handleKeyDown);

      return () => {
         document.removeEventListener('keydown', handleKeyDown);
      };
   }, []);
   const isAuthenticated = useSelector((state) => state.auth.login);
   const navigate = useNavigate();
   useEffect(() => {
      if (!isAuthenticated) {
         navigate('/auth/sign-in');
      }
   }, [isAuthenticated, navigate]);
   useEffect(() => {
      if (!isAuthenticated) return;

      // Main keyboard event handler
      const handleKeyDown = (event) => {
         if (!isAuthenticated) return;

         // Shift key shortcuts (work on all platforms)
         if (event.shiftKey && !event.ctrlKey && !event.metaKey) {
            switch (event.key.toLowerCase()) {
               case 's':
                  navigate('/admin/report/SalesDetail');
                  event.preventDefault();
                  break;
               case 'p':
                  navigate('/admin/report/PurchaseDetail');
                  event.preventDefault();
                  break;
               default:
                  break;
            }
         }
      };

      // Add event listener
      document.addEventListener('keydown', handleKeyDown);

      // Cleanup function
      return () => {
         document.removeEventListener('keydown', handleKeyDown);
      };
   }, [navigate, isAuthenticated]);

   const expandAll = useCallback(() => {
      const newExpanded = {};

      if (reportType === REPORT_TYPE.party) {
         // For party report type
         salesReport.forEach((companyData) => {
            const companyKey = `company-${companyData.companyId}`;
            newExpanded[companyKey] = true;

            companyData.data?.forEach((accountData) => {
               const accountKey = `account-${accountData.accountId}`;
               newExpanded[accountKey] = true;
            });
         });
      } else {
         // For other report types (date/broker)
         salesReport.forEach((dateItem) => {
            dateItem.data?.forEach((itemData) => {
               const itemKey = `item-${itemData.itemId}`;
               newExpanded[itemKey] = true;
            });
         });
      }

      setExpandedItems(newExpanded);
      setAllExpanded(true);
   }, [salesReport, reportType]);

   const collapseAll = useCallback(() => {
      const newExpanded = {};
      salesReport.forEach((companyData) => {
         const companyKey = `company-${companyData.companyId}`;
         newExpanded[companyKey] = true; // Keep companies expanded

         if (companyData.items) {
            companyData.items.forEach((itemData) => {
               const itemKey = `item-${itemData.item_id}-${companyData.companyId}`;
               newExpanded[itemKey] = false; // Collapse all items
            });
         }
      });
      setExpandedItems(newExpanded);
      setAllExpanded(false);
   }, [salesReport]);
   useEffect(() => {
      if (isFirstRenderFilter.current) {
         isFirstRenderFilter.current = false;
         return;
      }
      setIsFilterLoading(false);
   }, [salesReport]);

   const downloadExcel = useCallback(() => {
      if (!salesReport || salesReport.length === 0) {
         alert('No data available to export');
         return;
      }

      try {
         const wb = XLSX.utils.book_new();

         // Enhanced date parser that handles multiple formats
         const parseDate = (dateValue) => {
            if (!dateValue) return null;

            // If it's already a proper Date object
            if (dateValue instanceof Date && !isNaN(dateValue.getTime())) {
               return dateValue;
            }

            // If it's a timestamp (number or string representation)
            if (!isNaN(dateValue)) {
               const timestamp = Number(dateValue);
               // Check if it's milliseconds (13 digits) or seconds (10 digits)
               const date = timestamp > 9999999999 ? new Date(timestamp) : new Date(timestamp * 1000);
               if (!isNaN(date.getTime())) return date;
            }

            // If it's a string in ISO format (e.g., "2025-07-31T00:00:00.000Z")
            if (typeof dateValue === 'string' && dateValue.includes('T')) {
               const date = new Date(dateValue);
               if (!isNaN(date.getTime())) return date;
            }

            // If it's a string in "YYYY-MM-DD" format
            if (typeof dateValue === 'string' && dateValue.match(/^\d{4}-\d{2}-\d{2}$/)) {
               const [year, month, day] = dateValue.split('-');
               const date = new Date(year, month - 1, day);
               if (!isNaN(date.getTime())) return date;
            }

            // If it's a string in "DD/MM/YYYY" format
            if (typeof dateValue === 'string' && dateValue.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
               const [day, month, year] = dateValue.split('/');
               const date = new Date(year, month - 1, day);
               if (!isNaN(date.getTime())) return date;
            }

            console.warn('Could not parse date:', dateValue);
            return null;
         };

         // Format date for display
         const formatDateStrict = (date) => {
            if (!date) return '-';
            if (typeof date === 'string' && /^\d{2}-\d{2}-\d{4}$/.test(date)) {
               return date;
            }
            const parsedDate = parseDate(date);
            if (parsedDate) {
               return parsedDate
                  .toLocaleDateString('en-GB', {
                     day: '2-digit',
                     month: '2-digit',
                     year: 'numeric',
                  })
                  .replace(/\//g, '-');
            }
            return '-';
         };

         // Check format type
         const isDynamicFormat = dynamicValues && dynamicValues.includes(reportType);
         const selectedFormat = isDynamicFormat ? dynamicOptions?.find((opt) => opt.value === reportType) : null;
         const formatDefName = selectedFormat?.formatData?.defName;

         // Get columns
         const allColumns = getColumnsReportsSalesDetail
            ? getColumnsReportsSalesDetail(formatType, reportType)
            : dynamicColumns;

         // Filter columns similar to PDF logic
         const visibleColumns = allColumns.filter((col) => {
            if (columnVisibility && columnVisibility[col.id] === false) return false;
            if (col.isShow === false) return false;

            if (isTextile && (col.id === 'serialNo' || col.id === 'serial_no' || col.id === 'serialNumber')) {
               return false;
            }

            // Exclude HSN/SAC and Due Days columns for date-based reports
            const isDateBasedReport =
               reportType === REPORT_TYPE.date || reportType === 'date' || formatDefName === 'PurchaseDetailDate';

            if (isDateBasedReport) {
               const columnId = col.id?.toLowerCase() || '';
               const columnHeader = col.header?.toLowerCase() || '';

               if (
                  columnId.includes('hsn') ||
                  columnId.includes('sac') ||
                  columnHeader.includes('hsn') ||
                  columnHeader.includes('sac') ||
                  columnId.includes('due') ||
                  columnHeader.includes('due')
               ) {
                  return false;
               }
            }

            return true;
         });

         const sortedColumns = visibleColumns.sort((a, b) => {
            const orderA = a.orderNo || 0;
            const orderB = b.orderNo || 0;
            return orderA - orderB;
         });

         // Enhanced serial number extraction
         const getSerialNumber = (transaction, itemIndex = 0, isMultiItemMode = false) => {
            try {
               const serialFields = ['serialNo', 'serial_no', 'serialNumber', 'serial_number', 'serials', 'serialNos'];

               let serialValue = null;

               // For multi-item mode, get serial from specific item
               if (isMultiItemMode && transaction.purchaseLineItems && transaction.purchaseLineItems[itemIndex]) {
                  const item = transaction.purchaseLineItems[itemIndex];
                  for (const field of serialFields) {
                     if (item[field] !== undefined && item[field] !== null) {
                        serialValue = item[field];
                        break;
                     }
                  }
               }

               // Fallback to transaction level or first item
               if (!serialValue) {
                  for (const field of serialFields) {
                     if (transaction[field] !== undefined && transaction[field] !== null) {
                        serialValue = transaction[field];
                        break;
                     }
                  }

                  if (!serialValue && transaction.purchaseLineItems && Array.isArray(transaction.purchaseLineItems)) {
                     for (const lineItem of transaction.purchaseLineItems) {
                        for (const field of serialFields) {
                           if (lineItem[field] !== undefined && lineItem[field] !== null) {
                              serialValue = lineItem[field];
                              break;
                           }
                        }
                        if (serialValue) break;
                     }
                  }
               }

               if (serialValue !== null && serialValue !== undefined) {
                  if (Array.isArray(serialValue)) {
                     const filteredSerials = serialValue.filter((s) => s !== null && s !== undefined && s !== '');
                     return filteredSerials.length > 0 ? filteredSerials.join(', ') : 'No Serial';
                  } else if (typeof serialValue === 'string' || typeof serialValue === 'number') {
                     const serialStr = String(serialValue).trim();
                     return serialStr && serialStr !== '' ? serialStr : 'No Serial';
                  }
               }

               return 'No Serial';
            } catch (error) {
               console.error('Error getting serial number:', error);
               return 'Error';
            }
         };

         // Enhanced cell value extraction with multi-item support
         const getCellValue = (transaction, column, itemIndex = 0, isMultiItemMode = false) => {
            const accessor = column.accessor || column.id;
            let value = '';

            try {
               if (column.id === 'transactionAt') {
                  if (isMultiItemMode && itemIndex > 0) {
                     return '';
                  }
                  return formatDateStrict(transaction[accessor] || transaction.date || transaction.transactionDate);
               } else if (column.id === 'docno') {
                  if (isMultiItemMode && itemIndex > 0) {
                     return '';
                  }
                  const docno = transaction.docno || '';
                  const prefix = transaction.prefix || '';
                  const postFix = transaction.postFix || transaction.suffix || '';
                  return docno ? `${prefix}${docno}${postFix}` : '';
               } else if (column.id === 'itemName' || column.id === 'item_name') {
                  if (isMultiItemMode && transaction.purchaseLineItems && transaction.purchaseLineItems[itemIndex]) {
                     return transaction.purchaseLineItems[itemIndex].itemName || '';
                  }
                  return (
                     transaction.itemName || transaction.item_name || transaction.purchaseLineItems?.[0]?.itemName || ''
                  );
               } else if (column.id === 'serialNo' || column.id === 'serial_no') {
                  return getSerialNumber(transaction, itemIndex, isMultiItemMode);
               } else if (column.id === 'hsnSac') {
                  if (isMultiItemMode && transaction.purchaseLineItems && transaction.purchaseLineItems[itemIndex]) {
                     return transaction.purchaseLineItems[itemIndex].hsnSac || '';
                  }
                  return transaction.purchaseLineItems?.[0]?.hsnSac || '';
               } else if (column.id === 'itemRate') {
                  if (isMultiItemMode && transaction.purchaseLineItems && transaction.purchaseLineItems[itemIndex]) {
                     return Number(transaction.purchaseLineItems[itemIndex].itemRate || 0);
                  }
                  return Number(transaction.purchaseLineItems?.[0]?.itemRate || 0);
               } else if (column.id === 'totalQty1') {
                  if (isMultiItemMode && transaction.purchaseLineItems && transaction.purchaseLineItems[itemIndex]) {
                     return Number(transaction.purchaseLineItems[itemIndex].qty1 || 0);
                  } else if (
                     formatType === 'with_item_detail' &&
                     transaction.purchaseLineItems &&
                     transaction.purchaseLineItems.length > 0
                  ) {
                     return Number(transaction.purchaseLineItems[0].qty1 || 0);
                  }
                  return Number(transaction.totalQty1 || 0);
               } else if (column.id === 'lineNetAmount') {
                  if (isMultiItemMode && transaction.purchaseLineItems && transaction.purchaseLineItems[itemIndex]) {
                     return Number(transaction.purchaseLineItems[itemIndex].netAmt || 0);
                  } else if (
                     formatType === 'with_item_detail' &&
                     transaction.purchaseLineItems &&
                     transaction.purchaseLineItems.length > 0
                  ) {
                     return Number(transaction.purchaseLineItems[0].netAmt || 0);
                  }
                  return 0;
               } else if (
                  ['netAmount', 'billAmount', 'basicAmount', 'taxableAmount', 'gstAmount'].includes(column.id)
               ) {
                  if (isMultiItemMode && itemIndex > 0) {
                     return '';
                  }
                  let numValue = 0;
                  if (column.id === 'billAmount') {
                     numValue = Number(transaction.billAmount || transaction.netAmount || 0);
                  } else {
                     numValue = Number(transaction[column.id] || 0);
                  }
                  return numValue;
               } else if (['qty1', 'quantity'].includes(column.id)) {
                  if (isMultiItemMode && itemIndex > 0) {
                     return '';
                  }
                  return Number(transaction[column.id] || 0);
               } else {
                  // For non-item specific columns in multi-item mode, only show on first item
                  const nonItemColumns = ['accountname', 'daybookname', 'mobile', 'brokername', 'notes', 'dueDays'];
                  if (isMultiItemMode && itemIndex > 0 && nonItemColumns.includes(column.id)) {
                     return '';
                  }
                  const possibleFields = [accessor, column.id, accessor.replace(/([A-Z])/g, '_$1').toLowerCase()];
                  for (const field of possibleFields) {
                     if (transaction[field] !== undefined && transaction[field] !== null) {
                        return String(transaction[field]);
                     }
                  }
               }
            } catch (error) {
               console.error('Error getting cell value:', error);
            }

            return value || '';
         };

         // Extract all transactions from company data
         const extractAllTransactions = (companyData) => {
            const transactions = [];

            const findTransactions = (obj, path = '') => {
               if (!obj || typeof obj !== 'object') return;

               if (Array.isArray(obj)) {
                  obj.forEach((item, index) => {
                     if (
                        item &&
                        typeof item === 'object' &&
                        (item.billNo ||
                           item.docno ||
                           item.transactionAt ||
                           item.accountName ||
                           item.netAmount ||
                           item.itemName ||
                           item.basicAmount ||
                           item.partyName ||
                           item.brokerName)
                     ) {
                        transactions.push(item);
                     } else {
                        findTransactions(item, `${path}[${index}]`);
                     }
                  });
               } else {
                  Object.keys(obj).forEach((key) => {
                     findTransactions(obj[key], `${path}.${key}`);
                  });
               }
            };

            findTransactions(companyData.data);
            return transactions;
         };

         // Create Excel cell with proper formatting
         const createExcelCell = (value, column, isHeader = false) => {
            if (isHeader) {
               return {
                  v: column.header || column.id,
                  t: 's',
                  s: {
                     font: { bold: true, color: { rgb: column.color ? column.color.replace('#', '') : '000000' } },
                     fill: { fgColor: { rgb: 'D3D3D3' } },
                     alignment: { horizontal: 'center' },
                  },
               };
            }

            // Handle date formatting
            if (column.id === 'transactionAt' && value && value !== '-') {
               const date = parseDate(value);
               if (date) {
                  return {
                     v: date,
                     t: 'd',
                     s: { numFmt: 'dd-mm-yyyy' },
                  };
               }
            }

            // Handle numeric values
            if (
               column.isNumeric ||
               [
                  'netAmount',
                  'basicAmount',
                  'taxableAmount',
                  'gstAmount',
                  'itemRate',
                  'totalQty1',
                  'lineNetAmount',
               ].includes(column.id)
            ) {
               const numValue = Number(value);
               if (!isNaN(numValue)) {
                  return {
                     v: numValue,
                     t: 'n',
                     s: {
                        numFmt: column.id.toLowerCase().includes('qty') ? '#,##0' : '#,##0.00',
                        alignment: { horizontal: 'right' },
                        font: { color: { rgb: column.color ? column.color.replace('#', '') : '000000' } },
                     },
                  };
               }
            }

            // Default string formatting
            return {
               v: value || '',
               t: 's',
               s: {
                  font: { color: { rgb: column.color ? column.color.replace('#', '') : '000000' } },
               },
            };
         };

         // Process each company's data
         salesReport.forEach((companyData) => {
            if (!companyData) return;

            const companyName = companyData.companyName || `Company_${Math.random().toString(36).substring(2, 7)}`;
            const wsData = [];
            const merges = [];
            let currentRow = 0;

            // Determine if we should use dynamic or static processing
            if (isDynamicFormat) {
               // DYNAMIC FORMAT PROCESSING
               const allTransactions = extractAllTransactions(companyData);

               // Add company header with totals
               const companyTotal = allTransactions.reduce((sum, trans) => {
                  const amount = getCellValue(trans, { id: 'netAmount', isNumeric: true });
                  return sum + (Number(amount) || 0);
               }, 0);

               const totalQty = allTransactions.reduce((sum, trans) => {
                  const qty = getCellValue(trans, { id: 'totalQty1', isNumeric: true });
                  return sum + (Number(qty) || 0);
               }, 0);

               wsData.push([
                  {
                     v: `${companyName} (Qty: ${totalQty.toLocaleString()}, Total: ₹${companyTotal.toLocaleString()})`,
                     t: 's',
                     s: {
                        font: { bold: true, sz: 12 },
                        fill: { fgColor: { rgb: 'F1F0E8' } },
                        alignment: { horizontal: 'center' },
                     },
                  },
               ]);

               merges.push({ s: { r: currentRow, c: 0 }, e: { r: currentRow, c: sortedColumns.length - 1 } });
               currentRow++;

               wsData.push([]); // Empty row
               currentRow++;

               if (formatDefName === 'PurchaseDetailParty') {
                  // Group by party
                  const groupedByParty = {};
                  allTransactions.forEach((trans) => {
                     const party = trans.accountname || trans.partyName || trans.party_name || 'Unknown Party';
                     if (!groupedByParty[party]) groupedByParty[party] = [];
                     groupedByParty[party].push(trans);
                  });

                  Object.entries(groupedByParty).forEach(([partyName, partyTrans]) => {
                     const partyTotal = partyTrans.reduce((sum, trans) => {
                        const amount = getCellValue(trans, { id: 'netAmount', isNumeric: true });
                        return sum + (Number(amount) || 0);
                     }, 0);

                     const partyQty = partyTrans.reduce((sum, trans) => {
                        const qty = getCellValue(trans, { id: 'totalQty1', isNumeric: true });
                        return sum + (Number(qty) || 0);
                     }, 0);

                     // Party header
                     wsData.push([
                        {
                           v: `${partyName} (Qty: ${partyQty.toLocaleString()}, Amount: ₹${partyTotal.toLocaleString()})`,
                           t: 's',
                           s: {
                              font: { bold: true },
                              fill: { fgColor: { rgb: 'F5EEE6' } },
                              alignment: { horizontal: 'center' },
                           },
                        },
                     ]);
                     merges.push({ s: { r: currentRow, c: 0 }, e: { r: currentRow, c: sortedColumns.length - 1 } });
                     currentRow++;

                     // Column headers
                     wsData.push(sortedColumns.map((col) => createExcelCell(null, col, true)));
                     currentRow++;

                     // Transaction data
                     partyTrans.forEach((transaction) => {
                        if (
                           formatType === 'with_item_detail' &&
                           transaction.purchaseLineItems &&
                           transaction.purchaseLineItems.length > 1
                        ) {
                           transaction.purchaseLineItems.forEach((item, itemIndex) => {
                              const row = sortedColumns.map((col) =>
                                 createExcelCell(getCellValue(transaction, col, itemIndex, true), col),
                              );
                              wsData.push(row);
                              currentRow++;
                           });
                        } else {
                           const row = sortedColumns.map((col) => createExcelCell(getCellValue(transaction, col), col));
                           wsData.push(row);
                           currentRow++;
                        }
                     });

                     wsData.push([]); // Empty row after party
                     currentRow++;
                  });
               } else if (formatDefName === 'PurchaseDetailDate') {
                  // Group by date
                  const groupedByDate = {};
                  allTransactions.forEach((trans) => {
                     const date =
                        formatDateStrict(trans.transactionAt || trans.date || trans.transaction_date) || 'No Date';
                     if (!groupedByDate[date]) groupedByDate[date] = [];
                     groupedByDate[date].push(trans);
                  });

                  // Add column headers once for date format
                  wsData.push(sortedColumns.map((col) => createExcelCell(null, col, true)));
                  currentRow++;

                  Object.entries(groupedByDate).forEach(([date, dateTrans]) => {
                     const dateTotal = dateTrans.reduce((sum, trans) => {
                        const amount = getCellValue(trans, { id: 'netAmount', isNumeric: true });
                        return sum + (Number(amount) || 0);
                     }, 0);

                     const dateQty = dateTrans.reduce((sum, trans) => {
                        const qty = getCellValue(trans, { id: 'totalQty1', isNumeric: true });
                        return sum + (Number(qty) || 0);
                     }, 0);

                     // Date header
                     wsData.push([
                        {
                           v: `${date} (Qty: ${dateQty.toLocaleString()}, Amount: ₹${dateTotal.toLocaleString()})`,
                           t: 's',
                           s: {
                              font: { bold: true },
                              fill: { fgColor: { rgb: 'E5E5E5' } },
                              alignment: { horizontal: 'center' },
                           },
                        },
                     ]);
                     merges.push({ s: { r: currentRow, c: 0 }, e: { r: currentRow, c: sortedColumns.length - 1 } });
                     currentRow++;

                     // Transaction data
                     dateTrans.forEach((transaction) => {
                        if (
                           formatType === 'with_item_detail' &&
                           transaction.purchaseLineItems &&
                           transaction.purchaseLineItems.length > 1
                        ) {
                           transaction.purchaseLineItems.forEach((item, itemIndex) => {
                              const row = sortedColumns.map((col) =>
                                 createExcelCell(getCellValue(transaction, col, itemIndex, true), col),
                              );
                              wsData.push(row);
                              currentRow++;
                           });
                        } else {
                           const row = sortedColumns.map((col) => createExcelCell(getCellValue(transaction, col), col));
                           wsData.push(row);
                           currentRow++;
                        }
                     });
                  });
               } else {
                  // Default dynamic format - just list all transactions
                  wsData.push(sortedColumns.map((col) => createExcelCell(null, col, true)));
                  currentRow++;

                  allTransactions.forEach((transaction) => {
                     if (
                        formatType === 'with_item_detail' &&
                        transaction.purchaseLineItems &&
                        transaction.purchaseLineItems.length > 1
                     ) {
                        transaction.purchaseLineItems.forEach((item, itemIndex) => {
                           const row = sortedColumns.map((col) =>
                              createExcelCell(getCellValue(transaction, col, itemIndex, true), col),
                           );
                           wsData.push(row);
                           currentRow++;
                        });
                     } else {
                        const row = sortedColumns.map((col) => createExcelCell(getCellValue(transaction, col), col));
                        wsData.push(row);
                        currentRow++;
                     }
                  });
               }
            } else {
               // STATIC FORMAT PROCESSING
               if (reportType === REPORT_TYPE.party || reportType === 'party') {
                  // Add company header with totals
                  const companyTotal =
                     companyData.data?.reduce((sum, account) => sum + (account.totalNetAmt || 0), 0) || 0;
                  const totalQty = companyData.data?.reduce((sum, account) => sum + (account.totalQty1 || 0), 0) || 0;

                  wsData.push([
                     {
                        v: `${companyName} (Qty: ${totalQty.toLocaleString()}, Total: ₹${companyTotal.toLocaleString()})`,
                        t: 's',
                        s: {
                           font: { bold: true, sz: 12 },
                           fill: { fgColor: { rgb: 'F1F0E8' } },
                           alignment: { horizontal: 'center' },
                        },
                     },
                  ]);
                  merges.push({ s: { r: currentRow, c: 0 }, e: { r: currentRow, c: sortedColumns.length - 1 } });
                  currentRow++;

                  wsData.push([]); // Empty row
                  currentRow++;

                  // Process each account
                  companyData.data?.forEach((accountData) => {
                     if (!accountData) return;

                     const accountTotal = accountData.totalNetAmt || 0;
                     const accountQty = accountData.totalQty1 || 0;

                     // Add account header
                     wsData.push([
                        {
                           v: `${accountData.accountName
                              } (Qty: ${accountQty.toLocaleString()}, Amount: ₹${accountTotal.toLocaleString()})`,
                           t: 's',
                           s: {
                              font: { bold: true },
                              fill: { fgColor: { rgb: 'F5EEE6' } },
                              alignment: { horizontal: 'center' },
                           },
                        },
                     ]);
                     merges.push({ s: { r: currentRow, c: 0 }, e: { r: currentRow, c: sortedColumns.length - 1 } });
                     currentRow++;

                     // Add column headers
                     wsData.push(sortedColumns.map((col) => createExcelCell(null, col, true)));
                     currentRow++;

                     // Add transaction data
                     accountData.data?.forEach((transaction) => {
                        if (!transaction) return;

                        if (
                           formatType === 'with_item_detail' &&
                           transaction.purchaseLineItems &&
                           transaction.purchaseLineItems.length > 1
                        ) {
                           transaction.purchaseLineItems.forEach((item, itemIndex) => {
                              const row = sortedColumns.map((col) =>
                                 createExcelCell(getCellValue(transaction, col, itemIndex, true), col),
                              );
                              wsData.push(row);
                              currentRow++;
                           });
                        } else {
                           const row = sortedColumns.map((col) => createExcelCell(getCellValue(transaction, col), col));
                           wsData.push(row);
                           currentRow++;
                        }
                     });

                     wsData.push([]); // Empty row after account
                     currentRow++;
                  });
               } else {
                  // For date/broker report type
                  const allDateTransactions = companyData.data?.flatMap((item) => item.data || []) || [];

                  const companyTotal = allDateTransactions.reduce((sum, trans) => {
                     return sum + (Number(trans.netAmount) || 0);
                  }, 0);

                  const totalQty = allDateTransactions.reduce((sum, trans) => {
                     return sum + (Number(trans.totalQty1) || 0);
                  }, 0);

                  wsData.push([
                     {
                        v: `${companyName} (Qty: ${totalQty.toLocaleString()}, Total: ₹${companyTotal.toLocaleString()})`,
                        t: 's',
                        s: {
                           font: { bold: true, sz: 12 },
                           fill: { fgColor: { rgb: 'F1F0E8' } },
                           alignment: { horizontal: 'center' },
                        },
                     },
                  ]);
                  merges.push({ s: { r: currentRow, c: 0 }, e: { r: currentRow, c: sortedColumns.length - 1 } });
                  currentRow++;

                  wsData.push([]); // Empty row
                  currentRow++;

                  // Group by date
                  const groupedByDate = {};
                  allDateTransactions.forEach((trans) => {
                     const date = parseDate(trans.transactionAt);
                     const dateStr = date ? date.toLocaleDateString('en-GB') : 'No Date';
                     if (!groupedByDate[dateStr]) groupedByDate[dateStr] = [];
                     groupedByDate[dateStr].push(trans);
                  });

                  // Add column headers once
                  wsData.push(sortedColumns.map((col) => createExcelCell(null, col, true)));
                  currentRow++;

                  Object.entries(groupedByDate).forEach(([date, dateTransactions]) => {
                     const dateTotal = dateTransactions.reduce((sum, trans) => {
                        return sum + (Number(trans.netAmount) || 0);
                     }, 0);

                     const dateQty = dateTransactions.reduce((sum, trans) => {
                        return sum + (Number(trans.totalQty1) || 0);
                     }, 0);

                     // Add date header
                     wsData.push([
                        {
                           v: `${date} (Qty: ${dateQty.toLocaleString()}, Amount: ₹${dateTotal.toLocaleString()})`,
                           t: 's',
                           s: {
                              font: { bold: true },
                              fill: { fgColor: { rgb: 'E5E5E5' } },
                              alignment: { horizontal: 'center' },
                           },
                        },
                     ]);
                     merges.push({ s: { r: currentRow, c: 0 }, e: { r: currentRow, c: sortedColumns.length - 1 } });
                     currentRow++;

                     // Add transaction rows
                     dateTransactions.forEach((transaction) => {
                        if (
                           formatType === 'with_item_detail' &&
                           transaction.purchaseLineItems &&
                           transaction.purchaseLineItems.length > 1
                        ) {
                           transaction.purchaseLineItems.forEach((item, itemIndex) => {
                              const row = sortedColumns.map((col) =>
                                 createExcelCell(getCellValue(transaction, col, itemIndex, true), col),
                              );
                              wsData.push(row);
                              currentRow++;
                           });
                        } else {
                           const row = sortedColumns.map((col) => createExcelCell(getCellValue(transaction, col), col));
                           wsData.push(row);
                           currentRow++;
                        }
                     });
                  });
               }
            }

            // Create worksheet
            const ws = XLSX.utils.aoa_to_sheet(wsData);

            // Apply merges
            if (merges.length > 0) {
               ws['!merges'] = merges;
            }

            // Set column widths based on content
            const colWidths = sortedColumns.map((col) => {
               if (col.id === 'transactionAt') return { wch: 12 };
               if (
                  ['netAmount', 'billAmount', 'basicAmount', 'taxableAmount', 'gstAmount', 'itemRate'].includes(col.id)
               ) {
                  return { wch: 15 };
               }
               if (col.id === 'itemName') return { wch: 25 };
               if (col.id === 'accountName' || col.id === 'accountname') return { wch: 20 };
               if (col.id === 'serialNo' || col.id === 'serial_no') return { wch: 20 };
               if (col.id === 'docno') return { wch: 12 };

               const maxContentLength = Math.max(
                  col.header?.length || col.id.length,
                  15, // minimum width
               );

               return { wch: Math.min(Math.max(maxContentLength, 10), 30) };
            });

            ws['!cols'] = colWidths;

            // Add worksheet to workbook with safe sheet name
            const safeSheetName = companyName.substring(0, 31).replace(/[\\/*[\]:?]/g, '');
            XLSX.utils.book_append_sheet(wb, ws, safeSheetName);
         });

         // Generate and download the Excel file with timestamp
         const formatName = isDynamicFormat
            ? dynamicOptions?.find((opt) => opt.value === reportType)?.label || reportType
            : staticReportTypeOptions?.find((opt) => opt.value === reportType)?.label || reportType;

         const fileName = `${formatName}_Purchase_Detail_Report_${moment().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`;
         XLSX.writeFile(wb, fileName);
      } catch (error) {
         console.error('Error generating Excel file:', error);
         alert('Error generating Excel file. Please check console for details.');
      }
   }, [
      salesReport,
      reportType,
      dynamicColumns,
      columnVisibility,
      formatType,
      dynamicValues,
      dynamicOptions,
      getColumnsReportsSalesDetail,
      staticReportTypeOptions,
      isTextile
   ]);

   const downloadPDF = useCallback(() => {
      if (!salesReport || salesReport.length === 0) {
         alert('No data available to export');
         return;
      }

      const doc = new jsPDF({
         orientation: 'landscape',
         unit: 'mm',
      });

      const formatDateStrict = (date) => {
         if (!date) return '-';
         if (typeof date === 'string' && /^\d{2}-\d{2}-\d{4}$/.test(date)) {
            return date;
         }
         const m = moment(date);
         return m.isValid() ? m.format('DD-MM-YYYY') : '-';
      };

      // Color conversion utility (added from sales PDF)
      const convertBackendColor = (backendColor) => {
         if (!backendColor) return [0, 0, 0]; // Default black
         if (backendColor.startsWith('#')) {
            // Convert hex to RGB array for jsPDF
            const hex = backendColor.substring(1);
            const r = parseInt(hex.substring(0, 2), 16);
            const g = parseInt(hex.substring(2, 4), 16);
            const b = parseInt(hex.substring(4, 6), 16);
            return [r, g, b];
         }
         if (backendColor.startsWith('0xff')) {
            const hex = backendColor.substring(4);
            const r = parseInt(hex.substring(0, 2), 16);
            const g = parseInt(hex.substring(2, 4), 16);
            const b = parseInt(hex.substring(4, 6), 16);
            return [r, g, b];
         }
         if (/^[0-9A-Fa-f]{6}$/.test(backendColor)) {
            const r = parseInt(backendColor.substring(0, 2), 16);
            const g = parseInt(backendColor.substring(2, 4), 16);
            const b = parseInt(backendColor.substring(4, 6), 16);
            return [r, g, b];
         }
         return [0, 0, 0]; // Default black
      };

      // Add title
      const title = `Purchase Detail Report (${formatDateStrict(dateRange.fromDate)} to ${formatDateStrict(
         dateRange.toDate,
      )})`;
      doc.setFontSize(14);

      // Calculate center position for title
      const pdfWidth = doc.internal.pageSize.getWidth();
      const titleWidth = (doc.getStringUnitWidth(title) * doc.internal.getFontSize()) / doc.internal.scaleFactor;
      const titleXPosition = (pdfWidth - titleWidth) / 2;
      doc.text(title, titleXPosition, 10);

      // Add company filter info
      if (companyFilter && companyFilter.length > 0) {
         const companyNames = companyFilter
            .map((id) => {
               const company = companyList?.find((c) => c.id === id);
               return company ? company.name : '';
            })
            .filter((name) => name !== '')
            .join(', ');

         if (companyNames) {
            const companyText = `Companies: ${companyNames}`;
            doc.setFontSize(8);
            const companyWidth =
               (doc.getStringUnitWidth(companyText) * doc.internal.getFontSize()) / doc.internal.scaleFactor;
            const companyXPosition = (pdfWidth - companyWidth) / 2;
            doc.text(companyText, companyXPosition, 15);
         }
      }

      // Add report type info
      const reportTypeText = `Report Type: ${staticReportTypeOptions?.find((opt) => opt.value === reportType)?.label || reportType
         }`;
      doc.setFontSize(8);
      const reportTypeWidth =
         (doc.getStringUnitWidth(reportTypeText) * doc.internal.getFontSize()) / doc.internal.scaleFactor;
      const reportTypeXPosition = (pdfWidth - reportTypeWidth) / 2;
      doc.text(reportTypeText, reportTypeXPosition, 20);

      // Check format type
      const isDynamicFormat = dynamicValues && dynamicValues.includes(reportType);
      const selectedFormat = isDynamicFormat ? dynamicOptions?.find((opt) => opt.value === reportType) : null;
      const formatDefName = selectedFormat?.formatData?.defName;

      // Get columns
      const allColumns = getColumnsReportsSalesDetail
         ? getColumnsReportsSalesDetail(formatType, reportType)
         : dynamicColumns;

      // Filter out HSN/SAC and Due Days columns for date-based reports
      const visibleColumns = allColumns.filter((col) => {
         if (columnVisibility && columnVisibility[col.id] === false) return false;
         if (col.isShow === false) return false;

         // HIDE SERIAL NUMBER COLUMN FOR TEXTILE BUSINESS
         if (isTextile && (col.id === 'serialNo' || col.id === 'serial_no' || col.id === 'serialNumber')) {
            return false;
         }

         // Exclude HSN/SAC and Due Days columns for date-based reports
         const isDateBasedReport =
            reportType === REPORT_TYPE.date || reportType === 'date' || formatDefName === 'PurchaseDetailDate';

         if (isDateBasedReport) {
            const columnId = col.id?.toLowerCase() || '';
            const columnHeader = col.header?.toLowerCase() || '';

            if (
               columnId.includes('hsn') ||
               columnId.includes('sac') ||
               columnHeader.includes('hsn') ||
               columnHeader.includes('sac') ||
               columnId.includes('due') ||
               columnHeader.includes('due')
            ) {
               return false;
            }
         }

         return true;
      });

      const sortedColumns = visibleColumns.sort((a, b) => {
         const orderA = a.orderNo || 0;
         const orderB = b.orderNo || 0;
         return orderA - orderB;
      });

      // Calculate widths
      const totalFlex = sortedColumns.reduce((sum, col) => sum + (col.flex || 1), 0);
      const pageWidth = doc.internal.pageSize.getWidth() - 20;

      const calculateColumnWidth = (column) => {
         if (isTextile && (column.id === 'serialNo' || column.id === 'serial_no' || column.id === 'serialNumber')) {
            return 0; // This column won't be used anyway since we filtered it out
         }
         const baseFlex = column.flex || 1;

         // Enhanced width calculation for static format only
         if (!isDynamicFormat) {
            // Priority 1: Party/Account name columns (highest priority)
            const isPartyColumn = column.id === 'accountname' || column.id === 'accountName';

            if (isPartyColumn) {
               // Increase party column width by 60% more than normal calculation
               return Math.min((pageWidth * baseFlex * 1.6) / totalFlex, pageWidth * 0.25); // Max 25% of page width
            }

            // Priority 2: Item name columns (high priority)
            const isItemColumn = column.id === 'itemName';

            if (isItemColumn) {
               return Math.min((pageWidth * baseFlex * 1.4) / totalFlex, pageWidth * 0.22); // Max 22% of page width
            }

            // Priority 3: Daybook columns (high priority)
            const isDaybookColumn = column.id === 'daybookname';

            if (isDaybookColumn) {
               return Math.min((pageWidth * baseFlex * 1.3) / totalFlex, pageWidth * 0.18); // Max 18% of page width
            }

            // Priority 4: Serial Number columns - increased width for multi-line display
            const isSerialColumn =
               column.id === 'serialNo' || column.id === 'serial_no' || column.id === 'serialNumber';

            if (isSerialColumn) {
               return Math.min((pageWidth * baseFlex * 1.2) / totalFlex, pageWidth * 0.15); // Increased to 15% for multi-line serials
            }

            // Priority 5: Compressible columns (lower priority - can be reduced)
            const isCompressibleColumn = column.id === 'docno';

            if (isCompressibleColumn) {
               return Math.min((pageWidth * baseFlex * 0.6) / totalFlex, pageWidth * 0.08); // Reduced to max 8% of page width
            }

            // Priority 6: Quantity columns (can be compressed)
            const isQuantityColumn = column.id === 'totalQty1';

            if (isQuantityColumn) {
               return Math.min((pageWidth * baseFlex * 0.7) / totalFlex, pageWidth * 0.1); // Reduced to max 10% of page width
            }

            // Priority 7: Amount columns (can be compressed)
            const isAmountColumn =
               column.id === 'netAmount' ||
               (column.isNumeric &&
                  (column.header?.toLowerCase().includes('amount') || column.header?.toLowerCase().includes('amt')));

            if (isAmountColumn) {
               return Math.min((pageWidth * baseFlex * 0.8) / totalFlex, pageWidth * 0.12); // Reduced to max 12% of page width
            }

            const isRateColumn =
               column.id === 'itemRate' ||
               (column.isNumeric &&
                  (column.header?.toLowerCase().includes('amount') || column.header?.toLowerCase().includes('amt')));

            if (isRateColumn) {
               return Math.min((pageWidth * baseFlex * 0.8) / totalFlex, pageWidth * 0.2);
            }

            // Priority 8: Other important text columns (medium priority)
            const isImportantTextColumn =
               column.id === 'mobile' ||
               column.id === 'phone' ||
               column.id === 'brokername' ||
               column.id === 'brokerName' ||
               column.id === 'broker_name' ||
               column.id === 'notes' ||
               column.id === 'remarks' ||
               column.id === 'description';

            if (isImportantTextColumn) {
               return Math.min((pageWidth * baseFlex * 0.9) / totalFlex, pageWidth * 0.15); // Max 15% of page width
            }

            // Priority 9: Date columns (standard width)
            const isDateColumn = column.id === 'transactionAt' || column.id === 'transaction_at';

            if (isDateColumn) {
               return Math.min((pageWidth * baseFlex * 0.9) / totalFlex, pageWidth * 0.12); // Standard date width
            }

            // Default for other non-numeric columns - slightly reduced to compensate for priority columns
            if (!column.isNumeric) {
               return (pageWidth * baseFlex * 0.85) / totalFlex;
            }
         }

         // Default calculation for dynamic format or fallback
         return (pageWidth * baseFlex) / totalFlex;
      };

      // Enhanced columnStyles with improved serial number column styling
      const columnStyles = {};
      sortedColumns.forEach((col, index) => {
         const textColor = col.color ? convertBackendColor(col.color) : [0, 0, 0];
         const fontStyle =
            col.isBold && col.isItalic ? 'bolditalic' : col.isBold ? 'bold' : col.isItalic ? 'italic' : 'normal';

         // Check column types for special styling
         const isPartyColumn = col.id === 'accountname' || col.id === 'accountName';
         const isItemColumn = col.id === 'itemName';
         const isDaybookColumn = col.id === 'daybookname';
         const isSerialColumn = col.id === 'serialNo' || col.id === 'serial_no' || col.id === 'serialNumber';

         const isCompressibleColumn =
            col.id === 'docno' ||
            col.id === 'docNo' ||
            col.id === 'billno' ||
            col.id === 'billNo' ||
            col.id === 'qty' ||
            col.id === 'totalQty1' ||
            col.id === 'netAmount' ||
            col.id === 'billAmount' ||
            col.id === 'basicAmount';

         columnStyles[index] = {
            cellWidth: calculateColumnWidth(col),
            halign: col.isNumeric ? 'right' : 'left',
            cellPadding:
               isPartyColumn || isItemColumn || isDaybookColumn || isSerialColumn
                  ? 1.5
                  : isCompressibleColumn
                     ? 0.8
                     : 1,
            textColor: textColor,
            fontStyle: fontStyle,
            fontSize:
               isPartyColumn || isItemColumn || isDaybookColumn || isSerialColumn ? 8 : isCompressibleColumn ? 7 : 8,
            overflow: 'linebreak', // Allow text wrapping for important columns
            valign: 'top', // Changed from 'middle' to 'top' for better multi-line display
            // Add minimum width enforcement for priority columns
            minCellWidth: isPartyColumn
               ? 35
               : isItemColumn
                  ? 30
                  : isDaybookColumn
                     ? 25
                     : isSerialColumn
                        ? 20
                        : undefined,
         };
      });

      // Enhanced cell value function with multi-line serial number support
      const getCellValue = (transaction, column, itemIndex = 0, isMultiItemMode = false) => {
         const accessor = column.accessor || column.id;
         let value = '';

         try {
            if (column.id === 'transactionAt') {
               // For multi-item mode, only show date on first item
               if (isMultiItemMode && itemIndex > 0) {
                  value = '';
               } else {
                  value = formatDateStrict(transaction[accessor] || transaction.date || transaction.transactionDate);
               }
            } else if (column.id === 'docno') {
               if (isMultiItemMode && itemIndex > 0) {
                  value = '';
               } else {
                  const docno = transaction.docno || '';
                  const prefix = transaction.prefix || '';
                  const postFix = transaction.postFix || transaction.suffix || '';
                  value = docno ? `${prefix}${docno}${postFix}` : '';
               }
            } else if (column.id === 'itemName' || column.id === 'item_name') {
               if (isMultiItemMode && transaction.purchaseLineItems && transaction.purchaseLineItems[itemIndex]) {
                  value = transaction.purchaseLineItems[itemIndex].itemName || '';
               } else {
                  value =
                     transaction.itemName ||
                     transaction.item_name ||
                     transaction.purchaseLineItems?.[0]?.itemName ||
                     '';
               }
               value = String(value).replace(/\s+/g, ' ').substring(0, 40);
            } else if (column.id === 'serialNo' || column.id === 'serial_no' || column.id === 'serialNumber') {
               // Enhanced serial number handling for multi-line display
               if (isMultiItemMode && transaction.purchaseLineItems && transaction.purchaseLineItems[itemIndex]) {
                  const item = transaction.purchaseLineItems[itemIndex];
                  const serialNos = Array.isArray(item.serialNo) ? item.serialNo : [];

                  if (serialNos.length > 0) {
                     // Join serial numbers with newlines for multi-line display
                     value = serialNos.join('\n');
                  } else {
                     value = 'No Serial';
                  }
               } else {
                  // Original serial number extraction logic with multi-line support
                  let serialNos = [];

                  if (transaction.serialNo) {
                     serialNos = Array.isArray(transaction.serialNo)
                        ? transaction.serialNo
                        : [String(transaction.serialNo)];
                  } else if (transaction.serial_no) {
                     serialNos = Array.isArray(transaction.serial_no)
                        ? transaction.serial_no
                        : [String(transaction.serial_no)];
                  } else if (transaction.serialNumber) {
                     serialNos = Array.isArray(transaction.serialNumber)
                        ? transaction.serialNumber
                        : [String(transaction.serialNumber)];
                  } else if (transaction.purchaseLineItems && Array.isArray(transaction.purchaseLineItems)) {
                     serialNos = transaction.purchaseLineItems
                        .map((item) => item.serialNo || item.serial_no || item.serialNumber)
                        .filter((s) => s)
                        .flat();
                  }

                  if (serialNos.length > 0) {
                     // Join serial numbers with newlines for multi-line display
                     // Limit total characters to prevent overflow
                     const maxChars = 200;
                     let result = serialNos.join('\n');
                     if (result.length > maxChars) {
                        result = result.substring(0, maxChars) + '...';
                     }
                     value = result;
                  } else {
                     value = 'No Serial';
                  }
               }
            } else if (column.id === 'hsnSac') {
               if (isMultiItemMode && transaction.purchaseLineItems && transaction.purchaseLineItems[itemIndex]) {
                  value = transaction.purchaseLineItems[itemIndex].hsnSac || '';
               } else {
                  value = transaction.purchaseLineItems?.[0]?.hsnSac || '';
               }
            } else if (column.id === 'itemRate') {
               if (isMultiItemMode && transaction.purchaseLineItems && transaction.purchaseLineItems[itemIndex]) {
                  const itemRate = transaction.purchaseLineItems[itemIndex].itemRate || 0;
                  value = Number(itemRate).toLocaleString();
               } else {
                  const itemRate = transaction.purchaseLineItems?.[0]?.itemRate || 0;
                  value = Number(itemRate).toLocaleString();
               }
            } else if (column.id === 'totalQty1') {
               if (isMultiItemMode && transaction.purchaseLineItems && transaction.purchaseLineItems[itemIndex]) {
                  const qty = transaction.purchaseLineItems[itemIndex].qty1 || 0;
                  value = Number(qty).toLocaleString();
               } else if (
                  formatType === 'with_item_detail' &&
                  transaction.purchaseLineItems &&
                  transaction.purchaseLineItems.length > 0
               ) {
                  // For with_item_detail format, show ONLY the first item's quantity
                  value = Number(transaction.purchaseLineItems[0].qty1 || 0).toLocaleString();
               } else {
                  // For other formats, show transaction total quantity
                  value = Number(transaction.totalQty1 || 0).toLocaleString();
               }
            } else if (column.id === 'lineNetAmount') {
               if (isMultiItemMode && transaction.purchaseLineItems && transaction.purchaseLineItems[itemIndex]) {
                  const netAmt = transaction.purchaseLineItems[itemIndex].netAmt || 0;
                  value = Number(netAmt).toLocaleString();
               } else if (
                  formatType === 'with_item_detail' &&
                  transaction.purchaseLineItems &&
                  transaction.purchaseLineItems.length > 0
               ) {
                  value = Number(transaction.purchaseLineItems[0].netAmt || 0).toLocaleString();
               } else {
                  value = '0';
               }
            } else if (column.id === 'basicAmount') {
               if (isMultiItemMode && transaction.purchaseLineItems && transaction.purchaseLineItems[itemIndex]) {
                  const basicAmt =
                     transaction.purchaseLineItems[itemIndex].basicAmount ||
                     transaction.purchaseLineItems[itemIndex].netAmt ||
                     0;
                  value = Number(basicAmt).toLocaleString();
               } else if (isMultiItemMode && itemIndex > 0) {
                  value = ''; // Don't show transaction-level amounts on sub-items
               } else {
                  const rawValue = transaction[column.id];
                  if (rawValue !== null && rawValue !== undefined) {
                     const numValue = Number(rawValue);
                     value = isNaN(numValue) ? '0' : numValue.toLocaleString();
                  } else {
                     value = '0';
                  }
               }
            } else if (column.id === 'taxableAmount') {
               if (isMultiItemMode && transaction.purchaseLineItems && transaction.purchaseLineItems[itemIndex]) {
                  const taxableAmt =
                     transaction.purchaseLineItems[itemIndex].taxableAmount ||
                     transaction.purchaseLineItems[itemIndex].netAmt ||
                     0;
                  value = Number(taxableAmt).toLocaleString();
               } else if (isMultiItemMode && itemIndex > 0) {
                  value = '';
               } else {
                  const rawValue = transaction[column.id];
                  if (rawValue !== null && rawValue !== undefined) {
                     const numValue = Number(rawValue);
                     value = isNaN(numValue) ? '0' : numValue.toLocaleString();
                  } else {
                     value = '0';
                  }
               }
            } else if (column.id === 'gstAmount') {
               if (isMultiItemMode && transaction.purchaseLineItems && transaction.purchaseLineItems[itemIndex]) {
                  const item = transaction.purchaseLineItems[itemIndex];
                  const gstAmount = (item.cgst || 0) + (item.sgst || 0) + (item.igst || 0) + (item.cess || 0);
                  value = Number(gstAmount).toLocaleString();
               } else if (isMultiItemMode && itemIndex > 0) {
                  value = '';
               } else {
                  const rawValue = transaction[column.id];
                  if (rawValue !== null && rawValue !== undefined) {
                     const numValue = Number(rawValue);
                     value = isNaN(numValue) ? '0' : numValue.toLocaleString();
                  } else {
                     value = '0';
                  }
               }
            } else if (column.isNumeric || ['netAmount', 'billAmount'].includes(column.id)) {
               // For multi-item mode, only show bill/net amounts on first item to avoid duplication
               if (isMultiItemMode && itemIndex > 0) {
                  value = '';
               } else {
                  const possibleFields = [accessor, column.id, accessor.replace(/([A-Z])/g, '_$1').toLowerCase()];
                  let rawValue = null;
                  for (const field of possibleFields) {
                     if (transaction[field] !== undefined && transaction[field] !== null) {
                        rawValue = transaction[field];
                        break;
                     }
                  }
                  if (rawValue !== null && rawValue !== undefined) {
                     const numValue = Number(rawValue);
                     value = isNaN(numValue) ? '0' : numValue.toLocaleString();
                  } else {
                     value = '0';
                  }
               }
            } else {
               // For non-item specific columns in multi-item mode, only show on first item
               const nonItemColumns = ['accountname', 'daybookname', 'mobile', 'brokername', 'notes', 'dueDays'];
               if (isMultiItemMode && itemIndex > 0 && nonItemColumns.includes(column.id)) {
                  value = '';
               } else {
                  const possibleFields = [accessor, column.id, accessor.replace(/([A-Z])/g, '_$1').toLowerCase()];
                  for (const field of possibleFields) {
                     if (transaction[field] !== undefined && transaction[field] !== null) {
                        value = String(transaction[field]);
                        break;
                     }
                  }
               }
            }
         } catch (error) {
            console.error('Error getting cell value:', error);
            value = '';
         }

         return value || '';
      };

      // Enhanced transaction rows creation with multi-line serial number support
      const createPurchaseTransactionRows = (transactions, isMultiItemFormat = false) => {
         const rows = [];

         transactions.forEach((transaction) => {
            const hasMultipleItems =
               isMultiItemFormat &&
               transaction.purchaseLineItems &&
               Array.isArray(transaction.purchaseLineItems) &&
               transaction.purchaseLineItems.length > 1;

            if (hasMultipleItems) {
               // Create separate rows for each item
               transaction.purchaseLineItems.forEach((item, itemIndex) => {
                  const isFirstItem = itemIndex === 0;
                  const isLastItem = itemIndex === transaction.purchaseLineItems.length - 1;

                  const row = sortedColumns.map((col) => {
                     const textColor = col.color ? convertBackendColor(col.color) : [0, 0, 0];
                     const fontStyle =
                        col.isBold && col.isItalic
                           ? 'bolditalic'
                           : col.isBold
                              ? 'bold'
                              : col.isItalic
                                 ? 'italic'
                                 : 'normal';

                     const cellValue = getCellValue(transaction, col, itemIndex, true);
                     const isSerialColumn =
                        col.id === 'serialNo' || col.id === 'serial_no' || col.id === 'serialNumber';

                     return {
                        content: cellValue,
                        styles: {
                           fontSize: 8,
                           textColor: textColor,
                           fontStyle: fontStyle,
                           halign: col.isNumeric ? 'right' : 'left',
                           cellPadding: isSerialColumn ? 1.5 : 0.5, // Extra padding for serial numbers
                           // Add visual indication for sub-items
                           fillColor: isFirstItem ? null : '#F8FAFC',
                           // Only bottom border
                           lineWidth: { bottom: isLastItem ? 0.3 : 0.1 },
                           lineColor: [200, 200, 200],
                           valign: 'top', // Top alignment for multi-line content
                           overflow: 'linebreak',
                        },
                     };
                  });
                  rows.push(row);
               });
            } else {
               // Single row for single item or when not in multi-item format
               const row = sortedColumns.map((col) => {
                  const textColor = col.color ? convertBackendColor(col.color) : [0, 0, 0];
                  const fontStyle =
                     col.isBold && col.isItalic
                        ? 'bolditalic'
                        : col.isBold
                           ? 'bold'
                           : col.isItalic
                              ? 'italic'
                              : 'normal';

                  const cellValue = getCellValue(transaction, col, 0, false);
                  const isSerialColumn = col.id === 'serialNo' || col.id === 'serial_no' || col.id === 'serialNumber';

                  return {
                     content: cellValue,
                     styles: {
                        fontSize: 8,
                        textColor: textColor,
                        fontStyle: fontStyle,
                        halign: col.isNumeric ? 'right' : 'left',
                        cellPadding: isSerialColumn ? 1.5 : 0.5, // Extra padding for serial numbers
                        // Only bottom border
                        lineWidth: { bottom: 0.2 },
                        lineColor: [200, 200, 200],
                        valign: 'top', // Top alignment for multi-line content
                        overflow: 'linebreak',
                     },
                  };
               });
               rows.push(row);
            }
         });

         return rows;
      };

      // Enhanced header creation with top alignment for multi-line support
      const createDynamicHeader = () => {
         return sortedColumns.map((col) => {
            const textColor = col.color ? convertBackendColor(col.color) : [0, 0, 0];
            const fontStyle =
               col.isBold && col.isItalic ? 'bolditalic' : col.isBold ? 'bold' : col.isItalic ? 'italic' : 'normal';

            return {
               content: col.header || col.id,
               styles: {
                  fontSize: 7,
                  fontStyle: fontStyle,
                  textColor: textColor,
                  halign: col.isNumeric ? 'right' : 'left',
                  cellPadding: 1,
                  // Only bottom border for header
                  lineWidth: { bottom: 0.4 },
                  lineColor: [100, 100, 100],
                  valign: 'top', // Top alignment for headers too
               },
            };
         });
      };

      // Process data
      let data = [];
      const totalCols = sortedColumns.length;

      // Function to add a row with styling
      const addStyledRow = (content, colSpan = 1, styles = {}) => {
         const row = Array(totalCols).fill({ content: '', styles: {} });
         row[0] = {
            content,
            colSpan: Math.min(colSpan, totalCols),
            styles: {
               fillColor: styles.fillColor || null,
               fontStyle: styles.fontStyle || 'normal',
               textColor: styles.textColor || [0, 0, 0],
               fontSize: styles.fontSize || 8,
               cellPadding: styles.cellPadding || 1,
               halign: styles.halign || 'left',
               valign: 'top', // Top alignment for styled rows
               // Add bottom border for styled rows
               lineWidth: { bottom: 0.3 },
               lineColor: [150, 150, 150],
            },
         };
         data.push(row);
      };

      // Function to add transaction rows
      const addTransactionRows = (transactions) => {
         const transactionRows = createPurchaseTransactionRows(transactions, formatType === 'with_item_detail');
         data.push(...transactionRows);
      };

      // Function to calculate totals
      const calculateTotals = (transactions) => {
         const totals = {};
         sortedColumns.forEach((col) => {
            if (col.isNumeric || ['netAmount', 'basicAmount', 'totalQty1', 'billAmount'].includes(col.id)) {
               // Special handling for totalQty1 in with_item_detail format
               if (col.id === 'totalQty1' && formatType === 'with_item_detail') {
                  totals[col.id] = transactions.reduce((sum, trans) => {
                     // For with_item_detail, sum up all item quantities from purchaseLineItems
                     if (trans.purchaseLineItems && Array.isArray(trans.purchaseLineItems)) {
                        const transactionQty = trans.purchaseLineItems.reduce((itemSum, item) => {
                           return itemSum + (Number(item.qty1) || 0);
                        }, 0);
                        return sum + transactionQty;
                     }
                     // Fallback to totalQty1 if purchaseLineItems not available
                     return sum + (Number(trans.totalQty1) || 0);
                  }, 0);
               } else if (col.id === 'lineNetAmount' && formatType === 'with_item_detail') {
                  // For lineNetAmount, sum up all item amounts from purchaseLineItems
                  totals[col.id] = transactions.reduce((sum, trans) => {
                     if (trans.purchaseLineItems && Array.isArray(trans.purchaseLineItems)) {
                        const transactionAmt = trans.purchaseLineItems.reduce((itemSum, item) => {
                           return itemSum + (Number(item.netAmt) || 0);
                        }, 0);
                        return sum + transactionAmt;
                     }
                     return sum;
                  }, 0);
               } else {
                  // Default calculation for other columns
                  totals[col.id] = transactions.reduce((sum, trans) => {
                     const val = getCellValue(trans, col);
                     const numVal = Number(String(val).replace(/[₹,]/g, '')) || 0;
                     return sum + numVal;
                  }, 0);
               }
            }
         });
         return totals;
      };

      // MAIN PROCESSING LOGIC
      salesReport.forEach((companyData) => {
         const companyName = companyData.companyName;
         let allTransactions = [];

         // Extract transactions based on report type
         if (isDynamicFormat) {
            // For dynamic formats, use the flattened data
            allTransactions = companyData.data || [];
         } else {
            // For static formats, we need to extract from nested structure
            if (reportType === REPORT_TYPE.party || reportType === 'party') {
               // Extract from party-wise structure
               companyData.data?.forEach((accountData) => {
                  if (accountData.data) {
                     allTransactions = allTransactions.concat(accountData.data);
                  }
               });
            } else {
               // Extract from date-wise structure
               companyData.data?.forEach((dateData) => {
                  if (dateData.data) {
                     allTransactions = allTransactions.concat(dateData.data);
                  }
               });
            }
         }

         // Calculate company totals
         const companyTotals = calculateTotals(allTransactions);
         const qtyCol = sortedColumns.find(
            (col) => col.id === 'totalQty1' || col.id === 'qty' || col.header?.toLowerCase().includes('qty'),
         );
         const amountCol = sortedColumns.find(
            (col) =>
               ['netAmount', 'billAmount', 'basicAmount'].includes(col.id) ||
               col.header?.toLowerCase().includes('amount'),
         );

         const totalQty = qtyCol ? companyTotals[qtyCol.id] || 0 : 0;
         const totalAmount = amountCol ? companyTotals[amountCol.id] || 0 : 0;

         // Add company header with both Qty and Amt in the same row
         addStyledRow(
            `${companyName} (${allTransactions.length
            } transactions) Qty: ${totalQty.toLocaleString()} Amt: ${totalAmount.toLocaleString()}`,
            totalCols,
            {
               fillColor: '#F1F0E8',
               fontStyle: 'bold',
               fontSize: 9,
               cellPadding: 2,
            },
         );

         // Process based on format type
         if (isDynamicFormat) {
            if (formatDefName === 'PurchaseDetailParty') {
               // Group by party for dynamic party format
               const groupedByParty = {};
               allTransactions.forEach((trans) => {
                  const party = trans.accountname || trans.partyName || trans.party_name || 'Unknown Party';
                  if (!groupedByParty[party]) groupedByParty[party] = [];
                  groupedByParty[party].push(trans);
               });

               Object.entries(groupedByParty).forEach(([partyName, partyTrans]) => {
                  const partyTotals = calculateTotals(partyTrans);
                  const partyQty = qtyCol ? partyTotals[qtyCol.id] || 0 : 0;
                  const partyAmount = amountCol ? partyTotals[amountCol.id] || 0 : 0;

                  // Add party header
                  addStyledRow(
                     `${partyName} Qty: ${partyQty.toLocaleString()} Amt: ${partyAmount.toLocaleString()}`,
                     totalCols,
                     {
                        fillColor: '#F5EEE6',
                        fontStyle: 'bold',
                        fontSize: 8,
                        cellPadding: 1,
                     },
                  );

                  // Add transactions with multi-item support
                  addTransactionRows(partyTrans);
               });
            } else if (formatDefName === 'PurchaseDetailDate') {
               // Group by date for dynamic date format
               const groupedByDate = {};
               allTransactions.forEach((trans) => {
                  const date =
                     formatDateStrict(trans.transactionAt || trans.date || trans.transaction_date) || 'No Date';
                  if (!groupedByDate[date]) groupedByDate[date] = [];
                  groupedByDate[date].push(trans);
               });

               Object.entries(groupedByDate).forEach(([date, dateTrans]) => {
                  const dateTotals = calculateTotals(dateTrans);
                  const dateQty = qtyCol ? dateTotals[qtyCol.id] || 0 : 0;
                  const dateAmount = amountCol ? dateTotals[amountCol.id] || 0 : 0;

                  // Add date header
                  addStyledRow(
                     `${date} Qty: ${dateQty.toLocaleString()} Amt: ${dateAmount.toLocaleString()}`,
                     totalCols,
                     {
                        fillColor: '#E5E5E5',
                        fontStyle: 'bold',
                        fontSize: 8,
                        cellPadding: 1,
                     },
                  );

                  // Add transactions with multi-item support
                  addTransactionRows(dateTrans);
               });
            } else {
               // Default dynamic format - add all transactions directly with multi-item support
               addTransactionRows(allTransactions);
            }
         } else {
            // Static format processing with multi-item support
            if (reportType === REPORT_TYPE.party || reportType === 'party') {
               // Static party format
               if (companyData.data) {
                  companyData.data.forEach((accountData) => {
                     const accountTransactions = accountData.data || [];
                     const accountTotals = calculateTotals(accountTransactions);
                     const accountQty = qtyCol ? accountTotals[qtyCol.id] || 0 : 0;
                     const accountAmount = amountCol ? accountTotals[amountCol.id] || 0 : 0;

                     // Add account header
                     addStyledRow(
                        `${accountData.accountName
                        } Qty: ${accountQty.toLocaleString()} Amt: ${accountAmount.toLocaleString()}`,
                        totalCols,
                        {
                           fillColor: '#F5EEE6',
                           fontStyle: 'bold',
                           fontSize: 8,
                           cellPadding: 1,
                        },
                     );

                     // Add transactions with multi-item support
                     addTransactionRows(accountTransactions);
                  });
               }
            } else {
               // Static date format with multi-item support
               const itemData = companyData.data?.flatMap((item) => item.data || []) || [];

               // Group by date
               const groupedByDate = {};
               itemData.forEach((trans) => {
                  const date = formatDateStrict(trans.transactionAt) || 'No Date';
                  if (!groupedByDate[date]) groupedByDate[date] = [];
                  groupedByDate[date].push(trans);
               });

               Object.entries(groupedByDate).forEach(([date, dateTransactions]) => {
                  const dateTotals = calculateTotals(dateTransactions);
                  const dateQty = qtyCol ? dateTotals[qtyCol.id] || 0 : 0;
                  const dateAmount = amountCol ? dateTotals[amountCol.id] || 0 : 0;

                  // Add date header
                  addStyledRow(
                     `${date} Qty: ${dateQty.toLocaleString()} Amt: ${dateAmount.toLocaleString()}`,
                     totalCols,
                     {
                        fillColor: '#E5E5E5',
                        fontStyle: 'bold',
                        fontSize: 8,
                        cellPadding: 1,
                     },
                  );

                  // Add transactions with multi-item support
                  addTransactionRows(dateTransactions);
               });
            }
         }

         // Add spacing after company with subtle bottom border
         data.push(
            Array(totalCols).fill({
               content: '',
               styles: {
                  cellPadding: 2,
                  lineWidth: { bottom: 0.3 },
                  lineColor: [220, 220, 220],
               },
            }),
         );
      });

      // Generate table
      if (data.length === 0) {
         alert('No data found to generate PDF');
         return;
      }

      doc.autoTable({
         head: [createDynamicHeader()],
         body: data,
         startY: 25,
         margin: { left: 10, right: 10 },
         styles: {
            fontSize: 8,
            cellPadding: 1,
            overflow: 'linebreak',
            lineWidth: 0, // No borders by default
            valign: 'top', // Top alignment for all cells to support multi-line content
         },
         headStyles: {
            fillColor: [220, 220, 220],
            textColor: [0, 0, 0],
            fontStyle: 'bold',
            halign: 'center',
            fontSize: 7,
            lineWidth: { bottom: 0.4 }, // Only bottom border for header
            lineColor: [100, 100, 100],
            valign: 'top', // Top alignment for header
         },
         bodyStyles: {
            lineWidth: 0, // No borders for body
            valign: 'top', // Top alignment for body cells
         },
         alternateRowStyles: {
            fillColor: '#F8FAFC',
            lineWidth: 0, // No borders
            valign: 'top', // Top alignment for alternate rows
         },
         columnStyles: columnStyles,
         tableWidth: 'wrap',
         // Enhanced row height calculation for multi-line content
         didParseCell: function (data) {
            // Increase minimum row height for cells with multi-line content
            if (data.cell.text && typeof data.cell.text === 'string' && data.cell.text.includes('\n')) {
               const lineCount = data.cell.text.split('\n').length;
               data.cell.styles.minCellHeight = Math.max(data.cell.styles.minCellHeight || 0, lineCount * 4);
            }
         },
      });

      // Save PDF
      const formatName = isDynamicFormat
         ? dynamicOptions?.find((opt) => opt.value === reportType)?.label || reportType
         : staticReportTypeOptions?.find((opt) => opt.value === reportType)?.label || reportType;

      doc.save(`${formatName}_Report_${moment().format('YYYYMMDD_HHmmss')}.pdf`);
   }, [
      salesReport,
      dateRange.fromDate,
      dateRange.toDate,
      companyFilter,
      staticReportTypeOptions,
      reportType,
      dynamicValues,
      dynamicOptions,
      getColumnsReportsSalesDetail,
      formatType,
      dynamicColumns,
      companyList,
      columnVisibility,
   ]);

   // Add this function to calculate grand totals
   const calculateGrandTotals = useCallback(() => {
      if (!salesReport || salesReport.length === 0) return { totalQty: 0, totalAmt: 0 };

      let grandTotalQty = 0;
      let grandTotalAmt = 0;

      salesReport.forEach((companyData) => {
         if (isStaticReportType) {
            if (reportType === REPORT_TYPE.party || reportType === 'party') {
               // For party report type
               const companyQty = companyData.data?.reduce((sum, account) => sum + (account.totalQty1 || 0), 0) || 0;
               const companyAmt = companyData.data?.reduce((sum, account) => sum + (account.totalNetAmt || 0), 0) || 0;
               grandTotalQty += companyQty;
               grandTotalAmt += companyAmt;
            } else {
               // For date/broker report type
               const itemData = companyData.data?.flatMap((item) => item.data || []) || [];
               const companyQty = itemData.reduce((sum, trans) => sum + (Number(trans.totalQty1) || 0), 0);
               const companyAmt = itemData.reduce((sum, trans) => sum + (Number(trans.netAmount) || 0), 0);
               grandTotalQty += companyQty;
               grandTotalAmt += companyAmt;
            }
         } else {
            // For dynamic formats
            const transactions = companyData.data || [];
            const companyQty = transactions.reduce((sum, trans) => {
               if (formatType === 'with_item_detail' && trans.purchaseLineItems) {
                  return sum + trans.purchaseLineItems.reduce((itemSum, item) => itemSum + (Number(item.qty1) || 0), 0);
               }
               return sum + (Number(trans.totalQty1) || 0);
            }, 0);

            const companyAmt = transactions.reduce((sum, trans) => {
               if (formatType === 'with_item_detail' && trans.purchaseLineItems) {
                  return sum + trans.purchaseLineItems.reduce((itemSum, item) => itemSum + (Number(item.netAmt) || 0), 0);
               }
               return sum + (Number(trans.netAmount) || 0);
            }, 0);

            grandTotalQty += companyQty;
            grandTotalAmt += companyAmt;
         }
      });

      return { grandTotalQty, grandTotalAmt };
   }, [salesReport, reportType, formatType, isStaticReportType]);

   useEffect(() => {
      const calculateHeight = () => {
         const windowHeight = window.innerHeight;
         const headerHeight = 250; // Adjust based on your header/filters height
         const cardMargin = 15;
         const padding = 32;

         const availableHeight = windowHeight - headerHeight - cardMargin - padding;
         setContainerHeight(Math.max(availableHeight, 400)); // Minimum 400px
      };

      calculateHeight();
      window.addEventListener('resize', calculateHeight);
      return () => window.removeEventListener('resize', calculateHeight);
   }, []);

   // Flatten hierarchical data for virtualization
   const flattenHierarchicalData = useCallback(() => {
      if (!salesReport || salesReport.length === 0) return [];

      const flatItems = [];

      // Process based on report type
      if (isStaticReportType) {
         if (reportType === REPORT_TYPE.party || reportType === 'party') {

            // After processing all companies, add grand total row if multiple companies selected
            if (companyFilter.length > 1) {
               const { grandTotalQty, grandTotalAmt } = calculateGrandTotals();
               flatItems.push({
                  type: 'grand-total',
                  data: { totalQty: grandTotalQty, totalAmt: grandTotalAmt },
                  id: 'grand-total',
                  depth: 0,
               });
            }
            // Static party format
            salesReport.forEach((companyData, companyIndex) => {
               // Company header
               flatItems.push({
                  type: 'company-header',
                  data: companyData,
                  id: `company-${companyData.companyId || companyIndex}`,
                  companyId: companyData.companyId,
                  depth: 0,
               });

               // Only add accounts if company is expanded
               if (expandedItems[`company-${companyData.companyId}`] && companyData.data) {
                  companyData.data.forEach((accountData, accountIndex) => {
                     // Account header
                     flatItems.push({
                        type: 'account-header',
                        data: accountData,
                        id: `account-${accountData.accountId || accountIndex}`,
                        companyId: companyData.companyId,
                        accountId: accountData.accountId,
                        depth: 1,
                     });

                     // Only add transactions if account is expanded
                     if (expandedItems[`account-${accountData.accountId}`] && accountData.data) {
                        // Column headers - ONLY ONCE
                        flatItems.push({
                           type: 'column-headers',
                           data: null,
                           id: `headers-${accountData.accountId}`,
                           companyId: companyData.companyId,
                           accountId: accountData.accountId,
                           depth: 2,
                        });

                        // Transaction rows
                        accountData.data.forEach((transaction, transIndex) => {
                           const hasMultipleItems =
                              formatType === 'with_item_detail' &&
                              transaction.purchaseLineItems &&
                              Array.isArray(transaction.purchaseLineItems) &&
                              transaction.purchaseLineItems.length > 1;

                           // ALWAYS show the first transaction row
                           flatItems.push({
                              type: 'transaction-row',
                              data: transaction,
                              id: `trans-${transaction.id || transIndex}`,
                              companyId: companyData.companyId,
                              accountId: accountData.accountId,
                              depth: 2,
                              hasMultipleItems: hasMultipleItems,
                           });

                           // CRITICAL FIX: Show ALL additional items automatically
                           if (hasMultipleItems) {
                              transaction.purchaseLineItems.slice(1).forEach((item, itemIndex) => {
                                 flatItems.push({
                                    type: 'item-row',
                                    data: item,
                                    parentTransaction: transaction,
                                    id: `item-${itemIndex + 1}-${transaction.id}`,
                                    companyId: companyData.companyId,
                                    accountId: accountData.accountId,
                                    depth: 3,
                                 });
                              });
                           }
                        });
                     }
                  });
               }
            });
         } else {

            // After processing all companies, add grand total row if multiple companies selected
            if (companyFilter.length > 1) {
               const { grandTotalQty, grandTotalAmt } = calculateGrandTotals();
               flatItems.push({
                  type: 'grand-total',
                  data: { totalQty: grandTotalQty, totalAmt: grandTotalAmt },
                  id: 'grand-total',
                  depth: 0,
               });
            }
            // Static date format
            salesReport.forEach((companyData, companyIndex) => {
               // Company header
               flatItems.push({
                  type: 'company-header',
                  data: companyData,
                  id: `company-${companyData.companyId || companyIndex}`,
                  companyId: companyData.companyId,
                  depth: 0,
               });

               // Group by date
               const itemData = companyData.data?.flatMap((item) => item.data || []) || [];
               const groupedByDate = itemData.reduce((acc, item) => {
                  const date = item.transactionAt || 'No Date';
                  if (!acc[date]) acc[date] = [];
                  acc[date].push(item);
                  return acc;
               }, {});

               // Add column headers ONCE at company level
               flatItems.push({
                  type: 'column-headers',
                  data: null,
                  id: `headers-company-${companyData.companyId}`,
                  companyId: companyData.companyId,
                  depth: 1,
               });

               // Add date groups and transactions
               Object.entries(groupedByDate).forEach(([date, dateTransactions], dateIndex) => {
                  // Date header
                  flatItems.push({
                     type: 'date-header',
                     data: { date, transactions: dateTransactions },
                     id: `date-${date}-${dateIndex}`,
                     companyId: companyData.companyId,
                     depth: 1,
                  });

                  // Transaction rows
                  dateTransactions.forEach((transaction, transIndex) => {
                     const hasMultipleItems =
                        formatType === 'with_item_detail' &&
                        transaction.purchaseLineItems &&
                        Array.isArray(transaction.purchaseLineItems) &&
                        transaction.purchaseLineItems.length > 1;

                     // ALWAYS show the first transaction row
                     flatItems.push({
                        type: 'transaction-row',
                        data: transaction,
                        id: `trans-${transaction.id || transIndex}-${date}`,
                        companyId: companyData.companyId,
                        depth: 2,
                        hasMultipleItems: hasMultipleItems,
                     });

                     // CRITICAL FIX: Show ALL additional items automatically
                     if (hasMultipleItems) {
                        transaction.purchaseLineItems.slice(1).forEach((item, itemIndex) => {
                           flatItems.push({
                              type: 'item-row',
                              data: item,
                              parentTransaction: transaction,
                              id: `item-${itemIndex + 1}-${transaction.id}-${date}`,
                              companyId: companyData.companyId,
                              depth: 3,
                           });
                        });
                     }
                  });
               });
            });
         }
      } else {
         // Dynamic format processing
         const selectedFormat = dynamicOptions.find((opt) => opt.value === reportType);
         const formatDefName = selectedFormat?.formatData?.defName;

         salesReport.forEach((companyData, companyIndex) => {

            // After processing all companies, add grand total row if multiple companies selected
            if (companyFilter.length > 1) {
               const { grandTotalQty, grandTotalAmt } = calculateGrandTotals();
               flatItems.push({
                  type: 'grand-total',
                  data: { totalQty: grandTotalQty, totalAmt: grandTotalAmt },
                  id: 'grand-total',
                  depth: 0,
               });
            }
            // Company header
            flatItems.push({
               type: 'company-header',
               data: companyData,
               id: `company-${companyData.companyId || companyIndex}`,
               companyId: companyData.companyId,
               depth: 0,
            });

            const flattenedTransactions = companyData.data || [];

            if (formatDefName === 'PurchaseDetailParty') {
               // Group by party for dynamic party format
               const groupedByParty = flattenedTransactions.reduce((acc, trans) => {
                  const party = trans.accountname || trans.partyName || trans.party_name || 'Unknown Party';
                  if (!acc[party]) acc[party] = [];
                  acc[party].push(trans);
                  return acc;
               }, {});

               Object.entries(groupedByParty).forEach(([partyName, partyTrans], partyIndex) => {
                  // Party header
                  flatItems.push({
                     type: 'party-header',
                     data: { partyName, transactions: partyTrans },
                     id: `party-${partyName}-${partyIndex}`,
                     companyId: companyData.companyId,
                     depth: 1,
                  });

                  // Column headers - ONLY ONCE
                  flatItems.push({
                     type: 'column-headers',
                     data: null,
                     id: `headers-${partyName}-${partyIndex}`,
                     companyId: companyData.companyId,
                     depth: 2,
                  });

                  // Transaction rows
                  partyTrans.forEach((transaction, transIndex) => {
                     const hasMultipleItems =
                        formatType === 'with_item_detail' &&
                        transaction.purchaseLineItems &&
                        Array.isArray(transaction.purchaseLineItems) &&
                        transaction.purchaseLineItems.length > 1;

                     flatItems.push({
                        type: 'transaction-row',
                        data: transaction,
                        id: `trans-${transaction.id || transIndex}-${partyName}`,
                        companyId: companyData.companyId,
                        depth: 2,
                        hasMultipleItems: hasMultipleItems,
                     });

                     // CRITICAL FIX: Show ALL additional items
                     if (hasMultipleItems) {
                        transaction.purchaseLineItems.slice(1).forEach((item, itemIndex) => {
                           flatItems.push({
                              type: 'item-row',
                              data: item,
                              parentTransaction: transaction,
                              id: `item-${itemIndex + 1}-${transaction.id}-${partyName}`,
                              companyId: companyData.companyId,
                              depth: 3,
                           });
                        });
                     }
                  });
               });
            } else if (formatDefName === 'PurchaseDetailDate') {
               // Group by date for dynamic date format
               const groupedByDate = flattenedTransactions.reduce((acc, trans) => {
                  const date = trans.transactionAt || 'No Date';
                  if (!acc[date]) acc[date] = [];
                  acc[date].push(trans);
                  return acc;
               }, {});

               // Column headers ONCE at company level
               flatItems.push({
                  type: 'column-headers',
                  data: null,
                  id: `headers-company-${companyData.companyId}`,
                  companyId: companyData.companyId,
                  depth: 1,
               });

               Object.entries(groupedByDate).forEach(([date, dateTrans], dateIndex) => {
                  // Date header
                  flatItems.push({
                     type: 'date-header',
                     data: { date, transactions: dateTrans },
                     id: `date-${date}-${dateIndex}`,
                     companyId: companyData.companyId,
                     depth: 2,
                  });

                  // Transaction rows
                  dateTrans.forEach((transaction, transIndex) => {
                     const hasMultipleItems =
                        formatType === 'with_item_detail' &&
                        transaction.purchaseLineItems &&
                        Array.isArray(transaction.purchaseLineItems) &&
                        transaction.purchaseLineItems.length > 1;

                     flatItems.push({
                        type: 'transaction-row',
                        data: transaction,
                        id: `trans-${transaction.id || transIndex}-${date}`,
                        companyId: companyData.companyId,
                        depth: 3,
                        hasMultipleItems: hasMultipleItems,
                     });

                     // CRITICAL FIX: Show ALL additional items
                     if (hasMultipleItems) {
                        transaction.purchaseLineItems.slice(1).forEach((item, itemIndex) => {
                           flatItems.push({
                              type: 'item-row',
                              data: item,
                              parentTransaction: transaction,
                              id: `item-${itemIndex + 1}-${transaction.id}-${date}`,
                              companyId: companyData.companyId,
                              depth: 4,
                           });
                        });
                     }
                  });
               });
            } else {
               // Default dynamic format
               // Column headers ONCE
               flatItems.push({
                  type: 'column-headers',
                  data: null,
                  id: `headers-company-${companyData.companyId}`,
                  companyId: companyData.companyId,
                  depth: 1,
               });

               // All transactions
               flattenedTransactions.forEach((transaction, transIndex) => {
                  const hasMultipleItems =
                     formatType === 'with_item_detail' &&
                     transaction.purchaseLineItems &&
                     Array.isArray(transaction.purchaseLineItems) &&
                     transaction.purchaseLineItems.length > 1;

                  flatItems.push({
                     type: 'transaction-row',
                     data: transaction,
                     id: `trans-${transaction.id || transIndex}`,
                     companyId: companyData.companyId,
                     depth: 2,
                     hasMultipleItems: hasMultipleItems,
                  });

                  // CRITICAL FIX: Show ALL additional items
                  if (hasMultipleItems) {
                     transaction.purchaseLineItems.slice(1).forEach((item, itemIndex) => {
                        flatItems.push({
                           type: 'item-row',
                           data: item,
                           parentTransaction: transaction,
                           id: `item-${itemIndex + 1}-${transaction.id}`,
                           companyId: companyData.companyId,
                           depth: 3,
                        });
                     });
                  }
               });
            }
         });
      }

      return flatItems;
   }, [salesReport, reportType, formatType, expandedItems, isStaticReportType, dynamicOptions]);

   // Update flattened data when dependencies change
   useEffect(() => {
      if (salesReport.length > 0) {
         const flat = flattenHierarchicalData();
         setFlattenedData(flat);

         // Reset list to recalculate heights
         if (listRef.current) {
            listRef.current.resetAfterIndex(0);
         }
      }
   }, [salesReport, flattenHierarchicalData]);

   // Get item size (height) for each row type
   const getItemSize = useCallback(
      (index) => {
         const item = flattenedData[index];
         if (!item) return 40;

         switch (item.type) {
            case 'company-header':
               return 40;
            case 'account-header':
            case 'party-header':
            case 'date-header':
               return 30;
            case 'column-headers':
               return 35;
            case 'transaction-row':
               return 40;
            case 'item-row':
               return 40;
            case 'grand-total':
               return 45;
            default:
               return 40;
         }
      },
      [flattenedData],
   );

   // Helper function to format currency with small decimals
   const formatCurrencyWithSmallDecimals = useCallback((value) => {
      if (value == null || value === '') return '₹0';
      const numValue = Number(value);
      if (isNaN(numValue)) return '₹0';

      const formatted = numValue.toLocaleString('en-IN', {
         minimumFractionDigits: 2,
         maximumFractionDigits: 2,
      });

      const parts = formatted.toString().split('.');

      if (parts.length === 2) {
         return (
            <>
               ₹{parts[0]}.<span style={{ fontSize: '0.7em' }}>{parts[1]}</span>
            </>
         );
      }

      return `₹${formatted}`;
   }, []);

   // Add this helper function after your state declarations
   const formatDateForDisplay = useCallback((dateValue) => {
      if (!dateValue) return '-';

      // If already formatted as DD-MM-YYYY
      if (typeof dateValue === 'string' && /^\d{2}-\d{2}-\d{4}$/.test(dateValue)) {
         return dateValue;
      }

      // Try parsing with moment
      const m = moment(dateValue);
      if (m.isValid()) {
         return m.format('DD-MM-YYYY');
      }

      // If it's a timestamp
      if (!isNaN(dateValue)) {
         const timestamp = Number(dateValue);
         const date = timestamp > 9999999999 ? moment(timestamp) : moment(timestamp * 1000);
         if (date.isValid()) {
            return date.format('DD-MM-YYYY');
         }
      }

      return '-';
   }, []);

   // Handle transaction click
   const handleTransactionClick = useCallback(
      async (transaction) => {
         if (transaction.companyId === user?.loginhistory?.companyId && (admin || rights?.purchaseinvoice?.view)) {
            await dispatch(getPurchaseInvoice(transaction.id));
            setIsOpenPurchaseReturnSingleView(true);
         }
      },
      [dispatch, user?.loginhistory?.companyId, admin, rights?.purchaseinvoice?.view],
   );

   const RowRenderer = useCallback(
      ({ index, style }) => {
         const item = flattenedData[index];

         if (!item) return <div style={style} />;

         const getSortedVisibleColumns = () => {
            return table
               .getAllColumns()
               .filter((column) => column.getIsVisible())
               .filter((column) => {
                  if (column.id === 'serialNo' && isTextile) {
                     return false;
                  }
                  return true;
               })
               .sort((a, b) => {
                  const colA = dynamicColumns.find((col) => col.id === a.id);
                  const colB = dynamicColumns.find((col) => col.id === b.id);
                  const orderA = parseInt(colA?.orderNo) || 0;
                  const orderB = parseInt(colB?.orderNo) || 0;
                  return orderA - orderB;
               });
         };

         const renderContent = () => {
            switch (item.type) {

               case 'grand-total':
                  const grandTotalData = item.data;
                  return (
                     <Box
                        style={style}
                        bg={isDark ? '#1a3a6b' : '#E8E2D9'}
                        p="10px"
                        borderTop="3px solid"
                        borderBottom="2px solid"
                        borderColor={borderColor}
                        fontWeight="bold"
                        position="sticky"
                        bottom="0"
                        zIndex="3">
                        <Flex justifyContent="space-between" alignItems="center">
                           <Text
                              fontWeight="bold"
                              fontSize="16px"
                              color={`${isDark ? '#fff' : '#000'}`}>
                              GRAND TOTAL ({companyFilter.length} Companies)
                           </Text>
                           <Flex gap={6}>
                              <Text fontWeight="600" fontSize="15px" color={`${isDark ? '#fff' : '#000'}`}>
                                 Total Qty: {grandTotalData.totalQty.toLocaleString()}
                              </Text>
                              <Text fontWeight="bold" fontSize="15px" color={`${isDark ? '#fff' : '#000'}`}>
                                 Total Amt: ₹{grandTotalData.totalAmt.toLocaleString()}
                              </Text>
                           </Flex>
                        </Flex>
                     </Box>
                  );

               case 'company-header':
                  const company = item.data;
                  const companyTotalQty =
                     company.data?.reduce((sum, account) => sum + (account.totalQty1 || 0), 0) || 0;
                  const companyTotalAmt =
                     company.data?.reduce((sum, account) => sum + (account.totalNetAmt || 0), 0) || 0;

                  return (
                     <Box
                        style={style}
                        bg={isDark ? '#1a3a6b' : '#F1F0E8'}
                        p="8px"
                        borderBottom="2px solid"
                        borderColor={borderColor}
                        fontWeight="bold">
                        <Flex justifyContent="space-between" alignItems="center">
                           <Text
                              fontWeight="bold"
                              fontSize="16px"
                              color={`${isDark ? '#fff' : '#000'}`}
                              title={company.companyName}>
                              {company.companyName}
                           </Text>
                           <Flex gap={6}>
                              <Text fontWeight="600" fontSize="14px" color={`${isDark ? '#fff' : '#000'}`}>
                                 Qty: {companyTotalQty.toLocaleString()}
                              </Text>
                              <Text fontWeight="bold" fontSize="14px" color={`${isDark ? '#fff' : '#000'}`}>
                                 Amt: ₹{companyTotalAmt.toLocaleString()}
                              </Text>
                           </Flex>
                        </Flex>
                     </Box>
                  );

               case 'account-header':
                  const account = item.data;
                  return (
                     <Box
                        style={style}
                        bg={isDark ? '#1a3a6b' : '#F5EEE6'}
                        _dark={{ bg: 'blue.900' }}
                        p="6px"
                        pl="20px"
                        borderBottom="1px solid"
                        borderColor={borderColor}
                        cursor="pointer"
                        onClick={() => toggleExpand(`account-${item.accountId}`)}>
                        <Flex justifyContent="space-between" alignItems="center">
                           <Flex align="center" gap={2}>
                              <Text
                                 fontWeight="600"
                                 fontSize="14px"
                                 color={`${isDark ? '#fff' : '#000'}`}
                                 title={account.accountName}>
                                 {account.accountName}
                              </Text>
                              {expandedItems[`account-${item.accountId}`] ? <ChevronUpIcon /> : <ChevronDownIcon />}
                           </Flex>
                           <Flex gap={6}>
                              <Text fontWeight="600" fontSize="13px" color={`${isDark ? '#fff' : '#000'}`}>
                                 Qty: {account.totalQty1?.toLocaleString() || 0}
                              </Text>
                              <Text fontWeight="600" fontSize="13px" color={`${isDark ? '#fff' : '#000'}`}>
                                 Amt: ₹{account.totalNetAmt?.toLocaleString() || 0}
                              </Text>
                           </Flex>
                        </Flex>
                     </Box>
                  );

               case 'party-header':
                  const partyData = item.data;
                  const partyQty = partyData.transactions?.reduce((sum, t) => sum + (t?.totalQty1 || 0), 0) || 0;
                  const partyAmt = partyData.transactions?.reduce((sum, t) => sum + (t?.netAmount || 0), 0) || 0;

                  return (
                     <Box
                        style={style}
                        bg={isDark ? '#1a3a6b' : '#F5EEE6'}
                        p="6px"
                        pl="20px"
                        borderBottom="1px solid"
                        borderColor={borderColor}>
                        <Flex justifyContent="space-between" alignItems="center">
                           <Text
                              fontWeight="600"
                              fontSize="14px"
                              color={`${isDark ? '#fff' : '#000'}`}
                              title={partyData.partyName}>
                              {partyData.partyName}
                           </Text>
                           <Flex gap={6}>
                              <Text fontWeight="600" fontSize="13px" color={`${isDark ? '#fff' : '#000'}`}>
                                 Qty: {partyQty.toLocaleString()}
                              </Text>
                              <Text fontWeight="600" fontSize="13px" color={`${isDark ? '#fff' : '#000'}`}>
                                 Amt: ₹{partyAmt.toLocaleString()}
                              </Text>
                           </Flex>
                        </Flex>
                     </Box>
                  );

               case 'date-header':
                  const dateData = item.data;
                  const dateQty = dateData.transactions?.reduce((sum, t) => sum + (t?.totalQty1 || 0), 0) || 0;
                  const dateAmt = dateData.transactions?.reduce((sum, t) => sum + (t?.netAmount || 0), 0) || 0;

                  return (
                     <Box
                        style={style}
                        bg={isDark ? '#1a3a6b' : '#F5EEE6'}
                        p="6px"
                        borderBottom="1px solid"
                        borderColor={borderColor}>
                        <Flex justifyContent="space-between" alignItems="center">
                           <Text fontWeight="600" fontSize="13px" color={`${isDark ? '#fff' : '#000'}`}>
                              {formatDateForDisplay(dateData.date)}
                           </Text>
                           <Flex gap={6}>
                              <Text fontSize="13px" color={`${isDark ? '#fff' : '#000'}`}>
                                 Qty: {dateQty.toLocaleString()}
                              </Text>
                              <Text fontSize="13px" color={`${isDark ? '#fff' : '#000'}`}>
                                 Amt: ₹{dateAmt.toLocaleString()}
                              </Text>
                           </Flex>
                        </Flex>
                     </Box>
                  );

               case 'column-headers':
                  return (
                     <Grid
                        style={style}
                        templateColumns={`repeat(${getSortedVisibleColumns().length}, minmax(100px, 1fr))`}
                        bg={bg}
                        borderY="1px solid"
                        borderColor={borderColor}
                        position="sticky"
                        top="0"
                        zIndex="2"
                        fontWeight="700"
                        fontSize="12px">
                        {getSortedVisibleColumns().map((column) => {
                           const columnId = column.id;
                           const columnDef = dynamicColumns.find((col) => col.id === column.id);
                           const isNumericColumn =
                              columnDef?.isNumeric ||
                              ['netAmount', 'basicAmount', 'billAmount', 'dueDays', 'totalQty1', 'itemRate'].includes(
                                 columnId,
                              );

                           return (
                              <GridItem
                                 key={column.id}
                                 p="10px"
                                 cursor="pointer"
                                 textAlign={isNumericColumn ? 'right' : 'left'}
                                 color={`${isDark ? '#fff' : '#000'}`}
                                 onClick={column.getToggleSortingHandler()}>
                                 <Flex
                                    justifyContent={isNumericColumn ? 'flex-end' : 'flex-start'}
                                    align="center"
                                    gap={2}>
                                    {column.columnDef.header
                                       ? typeof column.columnDef.header === 'function'
                                          ? column.columnDef.header()
                                          : column.columnDef.header
                                       : columnId}
                                    {{
                                       asc: <ChevronUpIcon />,
                                       desc: <ChevronDownIcon />,
                                    }[column.getIsSorted()] ?? null}
                                 </Flex>
                              </GridItem>
                           );
                        })}
                     </Grid>
                  );

               case 'transaction-row':
                  const transaction = item.data;
                  const isOddRow = index % 2 !== 0;

                  return (
                     <Box
                        style={style}
                        onMouseDown={(e) => {
                           e.preventDefault();
                           e.stopPropagation();
                           handleTransactionClick(transaction);
                        }}
                        onClick={(e) => {
                           e.preventDefault();
                           e.stopPropagation();
                           handleTransactionClick(transaction);
                        }}>
                        <Grid
                           templateColumns={`repeat(${getSortedVisibleColumns().length}, minmax(100px, 1fr))`}
                           cursor="pointer"
                           onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleTransactionClick(transaction);
                           }}
                           bg={isDark
                              ? (isOddRow ? 'rgba(2, 14, 56, 0.7)' : 'transparent')
                              : (isOddRow ? 'rgba(0, 63, 140, 0.05)' : 'transparent')
                           }
                           _dark={{ bg: isOddRow ? 'rgba(2, 14, 56, 0.7)' : 'transparent' }}
                           _hover={{ bg: 'rgba(0, 63, 140, 0.08)' }}
                           borderBottom="1px solid"
                           borderColor={borderColor}
                           fontSize="13px"
                           position="relative"
                           zIndex={1}>
                           {getSortedVisibleColumns().map((column) => {
                              const columnDef = dynamicColumns.find((col) => col.id === column.id);
                              const cellStyles = {
                                 color: columnDef?.color || textColor,
                                 fontWeight: columnDef?.isBold ? 'bold' : 'normal',
                                 fontStyle: columnDef?.isItalic ? 'italic' : 'normal',
                              };
                              const isNumeric =
                                 columnDef?.isNumeric ||
                                 ['netAmount', 'basicAmount', 'billAmount', 'totalQty1', 'itemRate'].includes(
                                    column.id,
                                 );

                              let content = '-';
                              let titleText = '-';

                              if (column.id === 'transactionAt') {
                                 const dateValue =
                                    transaction.transactionAt || transaction.date || transaction.transactionDate;
                                 content = formatDateForDisplay(dateValue);
                                 titleText = content;
                              } else if (column.id === 'docno') {
                                 const docno = transaction.docno || transaction.docNo || '';
                                 const prefix = transaction.prefix || '';
                                 const postFix = transaction.postFix || transaction.suffix || '';
                                 content = docno ? `${prefix}${docno}${postFix}` : '-';
                                 titleText = content;
                              } else if (column.id === 'itemName' && formatType === 'with_item_detail') {
                                 if (
                                    transaction.purchaseLineItems &&
                                    Array.isArray(transaction.purchaseLineItems) &&
                                    transaction.purchaseLineItems.length > 0
                                 ) {
                                    const itemName = transaction.purchaseLineItems[0]?.itemName || '-';
                                    titleText = itemName;
                                    content = (
                                       <Text
                                          whiteSpace="nowrap"
                                          overflow="hidden"
                                          textOverflow="ellipsis"
                                          maxW="180px"
                                          title={itemName}>
                                          {itemName}
                                       </Text>
                                    );
                                 }
                              } else if (column.id === 'serialNo' && formatType === 'with_item_detail') {
                                 if (isTextile) {
                                    content = null; // Hide for TEXTILE
                                    titleText = '';
                                 } else {
                                    const item = transaction.purchaseLineItems?.[0];
                                    const serialNos = Array.isArray(item?.serialNo) ? item.serialNo : [];
                                    const serialText = serialNos.length > 0 ? serialNos.join(', ') : 'No Serial';
                                    titleText = serialText;
                                    content = serialNos.length > 0 ? (
                                       serialText
                                    ) : (
                                       <Text fontSize="11px" fontStyle="italic">
                                          No Serial
                                       </Text>
                                    );
                                 }
                              } else if (column.id === 'itemRate') {
                                 let rateValue = 0;

                                 if (
                                    transaction.purchaseLineItems &&
                                    Array.isArray(transaction.purchaseLineItems) &&
                                    transaction.purchaseLineItems.length > 0
                                 ) {
                                    const firstItem = transaction.purchaseLineItems[0];
                                    rateValue = firstItem.itemRate || firstItem.rate || 0;
                                 }

                                 if (!rateValue) {
                                    rateValue = transaction.itemRate || transaction.rate || 0;
                                 }

                                 content = formatCurrencyWithSmallDecimals(rateValue);
                                 titleText = String(rateValue);
                              } else if (column.id === 'totalQty1') {
                                 let qtyValue = 0;

                                 if (
                                    formatType === 'with_item_detail' &&
                                    transaction.purchaseLineItems &&
                                    transaction.purchaseLineItems.length > 0
                                 ) {
                                    qtyValue =
                                       transaction.purchaseLineItems[0].qty1 ||
                                       transaction.purchaseLineItems[0].qty ||
                                       0;
                                 }

                                 if (!qtyValue) {
                                    qtyValue =
                                       transaction.totalQty1 ||
                                       transaction.qty1 ||
                                       transaction.qty ||
                                       transaction.quantity ||
                                       0;
                                 }

                                 content = qtyValue;
                                 titleText = String(qtyValue);
                              } else if (isNumeric) {
                                 if (column.id === 'billAmount') {
                                    content = formatCurrencyWithSmallDecimals(
                                       transaction.basicAmount || transaction.netAmount,
                                    );
                                    titleText = String(transaction.basicAmount || transaction.netAmount);
                                 } else {
                                    content = formatCurrencyWithSmallDecimals(transaction[column.id]);
                                    titleText = String(transaction[column.id]);
                                 }
                              } else {
                                 content = transaction[column.id] || '-';
                                 titleText = content;
                              }

                              return (
                                 <GridItem
                                    key={column.id}
                                    p="10px"
                                    style={cellStyles}
                                    color={`${isDark ? '#fff' : '#000'}`}
                                    textAlign={isNumeric ? 'right' : 'left'}
                                    whiteSpace="nowrap"
                                    overflow="hidden"
                                    textOverflow="ellipsis"
                                    title={titleText}>
                                    {content}
                                 </GridItem>
                              );
                           })}
                        </Grid>
                     </Box>
                  );

               case 'item-row':
                  const itemData = item.data;
                  const parentTransaction = item.parentTransaction;

                  return (
                     <Grid
                        style={style}
                        templateColumns={`repeat(${getSortedVisibleColumns().length}, minmax(100px, 1fr))`}
                        cursor="pointer"
                        onClick={(e) => {
                           e.preventDefault();
                           e.stopPropagation();
                           console.log('click');
                           handleTransactionClick(parentTransaction);
                        }}
                        bg={isDark ? 'rgba(0, 123, 255, 0.1)' : 'rgba(0, 123, 255, 0.03)'}
                        borderLeft="3px solid"
                        borderLeftColor="blue.300"
                        borderBottom="1px solid"
                        borderColor={borderColor}
                        _hover={{ bg: 'rgba(0, 123, 255, 0.06)' }}
                        fontSize="12px">
                        {getSortedVisibleColumns().map((column) => {
                           let content = '';
                           let titleText = '';
                           const isNumeric = [
                              'netAmount',
                              'basicAmount',
                              'billAmount',
                              'totalQty1',
                              'itemRate',
                           ].includes(column.id);

                           if (column.id === 'itemName') {
                              content = itemData.itemName || '-';
                              titleText = itemData.itemName || '-';
                           } else if (column.id === 'serialNo') {
                              const serialNos = Array.isArray(itemData.serialNo) ? itemData.serialNo : [];
                              content = serialNos.length > 0 ? serialNos.join(', ') : 'No Serial';
                              titleText = content;
                           } else if (column.id === 'itemRate') {
                              const rateValue = itemData.itemRate || itemData.rate || 0;
                              content = formatCurrencyWithSmallDecimals(rateValue);
                              titleText = String(rateValue);
                           } else if (column.id === 'totalQty1') {
                              const qtyValue = itemData.qty1 || itemData.qty || itemData.quantity || 0;
                              content = qtyValue;
                              titleText = String(qtyValue);
                           }

                           return (
                              <GridItem
                                 key={column.id}
                                 p="10px"
                                 pl={column.id === 'itemName' ? '40px' : '10px'}
                                 color={`${isDark ? '#fff' : '#000'}`}
                                 textAlign={isNumeric ? 'right' : 'left'}
                                 whiteSpace="nowrap"
                                 overflow="hidden"
                                 textOverflow="ellipsis"
                                 title={titleText}>
                                 {content}
                              </GridItem>
                           );
                        })}
                     </Grid>
                  );

               default:
                  return <div style={style} />;
            }
         };

         return renderContent();
      },
      [
         flattenedData,
         isDark,
         borderColor,
         bg,
         table,
         dynamicColumns,
         formatType,
         toggleExpand,
         expandedItems,
         handleTransactionClick,
         formatCurrencyWithSmallDecimals,
         textColor,
         formatDateForDisplay,
      ],
   );

   useEffect(() => {
      if (salesReport.length > 0) {
         const flat = flattenHierarchicalData();
         setFlattenedData(flat);

         // Reset list to recalculate heights
         if (listRef.current) {
            listRef.current.resetAfterIndex(0);
         }
      }
   }, [salesReport, flattenHierarchicalData, calculateGrandTotals]);

   const deletePurchaseReturn = () => {
      const selectedDaybook = daybookData.find((db) => db.id === viewDetail?.daybookId);
      if (selectedDaybook && selectedDaybook?.askPasswordOnDelete) {
         setDataId({ id: viewDetail?.id, daybookId: viewDetail.daybookId, accountId: viewDetail.accountId });
         setIsModalOpen(true);
         setIsOpenPurchaseReturnSingleView(false);
      } else {
         deleteRecordForSales(
            viewDetail?.id,
            viewDetail?.daybookId,
            viewDetail?.accountId,
            deletePurchaseInvoice,
            dispatch,
            storedCompanyId,
            userGlobalSettingsData,
         );
         setIsOpenPurchaseReturnSingleView(false);
      }
      // deleteRecordForSales(
      //    viewDetail?.id,
      //    viewDetail?.daybookId,
      //    viewDetail?.accountId,
      //    deletePurchaseInvoice,
      //    dispatch,
      //    storedCompanyId,
      //    userGlobalSettingsData,
      // );
      // setIsOpenPurchaseReturnSingleView(false);
   };

   const handleSalesDetailsClose = () => {
      setIsOpenPurchaseReturnSingleView(false);
   };

   const handleShowHideFormOpen = async () => {
      setIsShowHideColumn(true);
      const formatData = reportformat.find((f) => f.title === reportType);
      if (formatData) {
         setIsEditShowHide(true);
         setEditData(formatData);
      } else {
         setIsEditShowHide(false);
         setEditData({});
      }
   };

   return (
      <>
         {/* Title Outside Card */}
         <Flex pr="25px" mb="5px" justifyContent="space-between" align="center" mt="50px" overflow={'hidden'}>
            <Flex>
               <img
                  src={back}
                  alt="Go Back"
                  width="15px"
                  onClick={() => window.history.back()} // Navigate to the previous page
                  style={{ cursor: 'pointer' }} // Ensure it's clickable
               ></img>
               <Text color={`${isDark ? '#fff' : '#000'}`} fontSize="15px" fontWeight="700" lineHeight="100%" ml={5}>
                  Purchase Invoice Detail
               </Text>
            </Flex>
            <Flex gap={2} justifyContent={'center'} alignItems={'center'}>
               <Box cursor={'pointer'} onClick={() => handleShowHideFormOpen()} mr={2}>
                  {isStaticReportType ? <FiPlusCircle size={22} /> : <LucideEdit size={22} />}
               </Box>
               <Button size="sm" variant="outline" onClick={expandAll} leftIcon={<MdExpand />}>
                  Expand All
               </Button>
               <Button size="sm" variant="outline" onClick={collapseAll} leftIcon={<MdCompress />}>
                  Collapse All
               </Button>
            </Flex>
         </Flex>

         <Box mt="15px" bg={backgroundColor} px={4} py={0} borderRadius="7px">
            <Flex alignItems="center" gap={3} justifyContent={'end'}>
               <div flex="1" mr={''} justifyContent="center">
                  <Box my={2} width="300px" fontSize={'13px'} fontWeight={500} display={{ base: 'none', xl: 'block' }}>
                     <GridItem className="seperator-width" mt={5}>
                        {renderDynamicDropdown(
                           'company',
                           'Company',
                           lastcompanyOptions,
                           {
                              value: companyFilter,
                              onChange: handleCompanyChange,
                           },
                           {},
                           textColor,
                           false,
                           'Select company',
                           true,
                           undefined,
                           true,
                        )}
                     </GridItem>
                  </Box>
               </div>
               <Box flex="1" display={{ base: 'none', xl: 'flex' }}>
                  <Flex alignItems={'center'} mt={3}>
                     <PeriodDatePicker
                        value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
                        onChange={handleDateRangeChange}
                        defaultPeriod="last7Days"
                        style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                     />
                  </Flex>
                  <Box my={2} zIndex={3} width={'150px'} fontSize={'13px'} fontWeight={500} mr={2}>
                     <label>Report Type</label>
                     <Select
                        options={reportTypeOptions}
                        formatOptionLabel={formatOptionLabel}
                        value={reportTypeOptions.find((option) => option.value === reportType)}
                        onChange={handleReportTypeChange}
                        placeholder="Select Report Type"
                        styles={{
                           control: (baseStyles, state) => ({
                              ...baseStyles,
                              minHeight: '30px',
                              height: '30px',
                              backgroundColor: controlBg,
                              borderColor: controlBorder,
                              boxShadow: state.isFocused ? focusBoxShadow : baseStyles.boxShadow,
                              '&:hover': {
                                 borderColor: controlBorderHover,
                              },
                           }),
                           valueContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                              padding: '0 6px',
                              color: textColor,
                           }),
                           indicatorsContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                           }),
                           singleValue: (baseStyles) => ({
                              ...baseStyles,
                              color: textColor,
                           }),
                           placeholder: (baseStyles) => ({
                              ...baseStyles,
                              color: placeholderColor,
                           }),
                           option: (baseStyles, state) => ({
                              ...baseStyles,
                              backgroundColor: state.isFocused ? optionHoverBg : optionBg,
                              color: textColor,
                              fontWeight: state.data?.isDynamic ? 'bold' : 'normal', // Style dynamic options differently
                              '&:hover': {
                                 backgroundColor: optionHoverBg,
                              },
                           }),
                           groupHeading: (baseStyles) => ({
                              ...baseStyles,
                              backgroundColor: menuBg,
                              border: `1px solid ${menuBorder}`,
                           }),
                           dropdownIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                           clearIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                        }}
                     />
                  </Box>
                  <Box my={2} zIndex={3} fontSize={'13px'} fontWeight={500}>
                     <label>Format</label>
                     <Select
                        options={formatTypeOptions}
                        value={reportTypeOptions.find((option) => option.value === formatType)}
                        onChange={(selectedOption) => {
                           setFormatType(selectedOption.value);
                           setExpandedItems({}); // Reset expanded items when changing report type
                        }}
                        defaultValue={formatType}
                        placeholder="Select Format Type"
                        styles={{
                           control: (baseStyles, state) => ({
                              ...baseStyles,
                              minHeight: '30px',
                              height: '30px',
                              backgroundColor: controlBg,
                              borderColor: controlBorder,
                              boxShadow: state.isFocused ? focusBoxShadow : baseStyles.boxShadow,
                              '&:hover': {
                                 borderColor: controlBorderHover,
                              },
                           }),
                           valueContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                              padding: '0 6px',
                              color: textColor,
                           }),
                           indicatorsContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                           }),
                           singleValue: (baseStyles) => ({
                              ...baseStyles,
                              color: textColor,
                           }),
                           placeholder: (baseStyles) => ({
                              ...baseStyles,
                              color: placeholderColor,
                           }),
                           option: (baseStyles, state) => ({
                              ...baseStyles,
                              backgroundColor: state.isFocused ? optionHoverBg : optionBg,
                              color: textColor,
                              '&:hover': {
                                 backgroundColor: optionHoverBg,
                              },
                           }),
                           menu: (baseStyles) => ({
                              ...baseStyles,
                              backgroundColor: menuBg,
                              border: `1px solid ${menuBorder}`,
                           }),
                           dropdownIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                           clearIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                        }}
                     />
                  </Box>
               </Box>
               <Flex>
                  <Flex alignItems="center">
                     <Flex mr={2}>
                        <Box flex="1" mr={3}>
                           <MotionFlex
                              ref={wrapperRef}
                              align="center"
                              bg={bg}
                              borderRadius="full"
                              cursor="pointer"
                              px={expanded ? 3 : 0}
                              w={expanded ? '250px' : '40px'} // Wider for full input
                              h="40px"
                              transition="all 0.3s ease"
                              onClick={() => setExpanded(true)}>
                              <MotionSearchIcon
                                 color={icon}
                                 animate={{ rotate: expanded ? 0 : 90 }}
                                 transition={{ duration: 0.3 }}
                                 style={{
                                    marginRight: expanded ? '8px' : '10px',
                                    marginLeft: expanded ? '0' : '10px',
                                 }}
                              />
                              {expanded && (
                                 <Input
                                    variant="unstyled"
                                    placeholder="Search ..."
                                    value={searchQuery}
                                    onChange={handleSearchChange}
                                    autoFocus
                                    color={icon}
                                    flex="1"
                                 />
                              )}
                           </MotionFlex>
                        </Box>
                        <Button onClick={() => fetchData()} _hover={{ bg: 'blue.50' }} mr={2}>
                           <MdOutlineRefresh size={20} mr={2} />
                        </Button>

                        <Button cursor={'pointer'} onClick={onFilterOpen} mr={2}>
                           <IoFilterOutline size={22} />
                        </Button>
                     </Flex>
                     <Flex mr={2}>
                        <Popover>
                           <PopoverTrigger>
                              <IconButton
                                 icon={<Image src={Download} boxSize="24px" />}
                                 aria-label="Download Options"
                              // variant="outline"
                              />
                           </PopoverTrigger>

                           <PopoverContent width="220px" zIndex="10" bg={backgroundColor} mr={8}>
                              <PopoverBody p="3">
                                 <Button
                                    width="100%"
                                    variant="ghost"
                                    _hover={{ bg: 'blue.100' }}
                                    onClick={downloadExcel}
                                    justifyContent="space-between"
                                    mb={3}>
                                    <img src={xls} alt="Download XLS" width="30px"></img>
                                    Download Excel
                                 </Button>
                                 <Button
                                    width="100%"
                                    variant="ghost"
                                    _hover={{ bg: 'blue.100' }}
                                    onClick={downloadPDF}
                                    justifyContent="space-between">
                                    <img src={xls} alt="Download PDF" width="30px"></img>
                                    Download PDF
                                 </Button>
                              </PopoverBody>
                           </PopoverContent>
                        </Popover>
                     </Flex>
                  </Flex>
               </Flex>
               <Box ml={1}>
                  <Flex display={{ base: 'block', xl: 'none' }}>
                     <Button variant="unstyled" onClick={onOpen}>
                        <Image src={DotIcon} alt="Menu" width="25px" />
                     </Button>
                  </Flex>
               </Box>

               <Drawer isOpen={isOpen} placement="bottom" onClose={onClose} finalFocusRef={fromDateInputRef}>
                  <DrawerOverlay />
                  <DrawerContent borderTopRadius="20px">
                     <DrawerCloseButton />
                     <DrawerHeader borderBottomWidth="1px">Filters</DrawerHeader>
                     <DrawerBody>
                        <GridItem className="seperator-width">
                           {renderDynamicDropdown(
                              'company',
                              'Company',
                              lastcompanyOptions,
                              {
                                 value: companyFilter, // Filter based on companyFilter values
                                 onChange: handleCompanyChange, // Handle change
                              },
                              {},
                              textColor,
                              false,
                              'Select company',
                              true, // isSearchable
                              undefined, // filteredOptions (optional, can be null or undefined)
                              true, // isMulti
                           )}
                        </GridItem>
                        <Box my={2} fontSize={'13px'} fontWeight={500}>
                           <label>Report Type</label>
                           <Select
                              options={reportTypeOptions}
                              value={reportTypeOptions.find((option) => option.value === reportType)}
                              onChange={(selectedOption) => {
                                 setReportType(selectedOption.value);
                                 setExpandedItems({}); // Reset expanded items when changing report type
                              }}
                              placeholder="Select Report Type"
                           />
                        </Box>
                        <Box alignItems={'center'} mt={3}>
                           <PeriodDatePicker
                              value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
                              onChange={handleDateRangeChange}
                              defaultPeriod="last7Days"
                              style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                           />
                        </Box>

                        <Button colorScheme="green" width="100%" onClick={onClose} mt={4}>
                           Apply Filters
                        </Button>
                     </DrawerBody>
                  </DrawerContent>
               </Drawer>
            </Flex>
         </Box>

         <Grid overflow="auto">
            <Card mt="15px" borderRadius="7px">
               <Box
                  overflowX="auto"
                  className="custom-scrollbar"
                  position="relative"
                  minH={{ base: '60vh', md: '65vh', xl: '70vh' }}
                  maxH={{ base: '60vh', md: '65vh', xl: '70vh' }}
                  width="100%"
                  height={`${containerHeight}px`} // Use calculated height
                  id="purchase-detail-container">
                  {isFilterLoading && (
                     <Box
                        position="fixed"
                        top={0} left={0} right={0} bottom={0}
                        zIndex={9999}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        bg={isDark ? 'rgba(10,20,50,0.60)' : 'rgba(255,255,255,0.60)'}
                        backdropFilter="blur(3px)"
                     >
                        <Flex direction="column" align="center" gap={3}>
                           <Loader />
                        </Flex>
                     </Box>
                  )}
                  {isLoading ? (
                     <Loader />
                  ) : flattenedData.length === 0 ? (
                     <Box width="100%" height="100%" display="flex" alignItems="center" justifyContent="center">
                        <Flex direction="column" align="center" justify="center">
                           <img src={nodata} alt="No Data Found" width="200px" height="200px" />
                           <Text mt={4}>No purchase data found</Text>
                        </Flex>
                     </Box>
                  ) : (
                     <VariableSizeList
                        key={colorMode}
                        ref={listRef}
                        height={containerHeight}
                        width="100%"
                        itemCount={flattenedData.length}
                        itemSize={getItemSize}
                        overscanCount={15}
                        estimatedItemSize={50}>
                        {RowRenderer}
                     </VariableSizeList>
                  )}
               </Box>
            </Card>
         </Grid>

         <SalesPurchaseFilter
            type={reportType}
            isOpen={isFilterOpen}
            onClose={onFilterClose}
            companyIds={companyIds}
            fromDate={dateRange.fromDate}
            toDate={dateRange.toDate}
            entityType="purchaseDetail"
            onApply={() => setIsFilterLoading(true)}
         />

         <ColumnShowHide
            isOpen={isShowHideColumn}
            onClose={() => setIsShowHideColumn(false)}
            data={columnsData}
            setShowHideData={setShowHideData}
            isedit={isEditShowHide}
            editData={editData}
            selectedFormat={reportTypeOptions.dynamicOptions}
            FixdefName1={'PurchaseDetailDate'}
            FixdefName2={'PurchaseDetailParty'}
            FixdefName3={'PurchaseDetailBroker'}
            staticOption={staticOption}
            dynamicEditOption={dynamicEditOption}
         />

         {/* Column Visibility Modal */}
         <SalesDetails
            isOpen={isOpenPurchaseReturnSingleView}
            onClose={handleSalesDetailsClose}
            singleEntityRights={purchaseInvoiceRight || purchaseReturnRight}
            title={'Purchase Invoice'}
            entityType={'purchaseinvoice'}
            singleEntity={viewDetail}
            handlePrevPage={handlePrevPage}
            handleNextPage={handleNextPage}
            setIsEditFormOpen={setIsEditFormOpen}
            setIsOpenSingleView={setIsOpenPurchaseReturnSingleView}
            isEditFormOpen={isEditFormOpen}
            // paginate={paginateData}
            viewDetail={viewDetail}
            lineItems={viewDetail?.lineitems}
            billTerms={viewDetail?.purchasereturnbillteams}
            onDelete={deletePurchaseReturn}
            handleSerchClose={() => console.log('')}
         />

         <DeletePasswordModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onConfirm={deleteRecordForSales}
            id={dataId}
            deleteApi={deletePurchaseInvoice}
            dispatch={dispatch}
            type="purchase"
            userGlobalSettingsData={userGlobalSettingsData}
         />
      </>
   );
};

export default PurchaseDetail;
